import {
    Box, AppBar, Toolbar, useTheme,
    Grid, Menu, CardHeader, DialogTitle, FormControlLabel, ListItemIcon, ListItemText, Dialog, DialogActions, DialogContent, Button, Checkbox, Table, TableCell, TableBody, TableContainer, TableHead, TableRow, Tooltip, Divider, MenuItem, Card, CardContent, TextField, Typography, FormControl, Stack, Chip, Autocomplete, Alert, IconButton,
    alpha
} from "@mui/material";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { useState, useEffect } from "react";

import CallAlertBar from "../../../Layout/Alertbar";
import ViewChildReelTable from "./ChildReelTable";
import ViewTableData from "../../../components/templates/viewTable";
import AddOperator from "../../master/AddOperator";

import LoadChildRollDetailsInQRCode from "../qrcode/ChildRollDetailsInQRCode";
import UpdateChildRollDetail from "./UpdateChildRollDetail";
import qrcode from 'qrcode';
import { useTranslation } from "react-i18next";
import QualityCheckRejectProcee from "../qc/QCRejectReelProcess";
import ProductionBreakProcess from "../break/ProductionBreak";



import ReverseChildRollDetail from "./ReverseChildRollDetail";
import LabelChildRollDetails from "../labels/ChildRoll";
import GlobalConfig from "../../../config/date/GlobalConfig";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import FormulaReelWeightCalculation from "../formula/ReelWeightCalculation";

// icon 
import Close from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import EditIcon from '@mui/icons-material/Edit';
import SummarizeIcon from '@mui/icons-material/Summarize';
import HelpIcon from '@mui/icons-material/ContactSupport';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';
import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import DangerousOutlinedIcon from '@mui/icons-material/DangerousOutlined';
import InfoIcon from '@mui/icons-material/Info';


// message bar
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import Header from "../../../Layout/Header";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { tokens } from "../../../theme/theme";
import AddExtraSetProduction from "./AddExtraSetProduction";
import ReelTransferProcess from "./TransferReel";
import useGetActualSetCount from "../../../hooks/useGetActualSetCount";
import DialogBox from "../../../components/form/DialogBox";
import ReportWinderProuctionWIPReelsList from "../reports/ReportWinderProuctionWIPReelsList";
import { Replay } from "@mui/icons-material";

const WinderMachineProduction = ({ editParentRollID, handleBackWinderMachineEntry }) => {
    const [parentRollOrderFromDate, setParentRollOrderFromDate] = useState(dayjs());
    const [parentRollorderToDate, setParentRollOrderToDate] = useState(dayjs());

    const [parentRollNumbers, setparentRollNumbers] = useState([]);
    const [selectedParentRollNumber, setSelectedParentRollNumber] = useState(null);

    const [diffParentRollNumbers, setDiffParentRollNumbers] = useState([]);
    const [selectedDiffParentRollNumber, setSelectedDiffParentRollNumber] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    // alert message
    const [open, setOpen] = useState(false);
    const [severityvalue, setseverityvalue] = useState('info');
    const [messageValue, setmessageValue] = useState('welcome to winder reel production ');
    const [alertTitleValue, setAlertTitleValue] = useState('info');

    const [period, setPeriod] = useState('All');

    const [parentRollDetails, setParentRollDetails] = useState([]);
    const [winderMONumber, setWinderMONumber] = useState(0);
    const [winderMANumber, setWinderMANumber] = useState(0);
    const [winderTotalSets, setWinderTotalSets] = useState(0);
    const [winderBulk, setWinderBulk] = useState(0);
    const [winderRemarks, setWinderRemarks] = useState('');
    const [winderOperators, setWinderOperators] = useState('');
    const [winderShiftCode, setWinderShiftCode] = useState('');
    const [winderShiftID, setWinderShiftID] = useState(0);
    const [winderShiftDate, setWinderShiftDate] = useState(dayjs());
    const [shiftCodes, setShiftCodes] = useState([]);
    const [shiftDate, setShiftDate] = useState(dayjs());

    const [availableSetLength, setAvailableSetLength] = useState(0);
    const [gsm, setGSM] = useState(0);
    const [jumboValue, setJumboValue] = useState(0);
    const [achievedDeckleValue, setAchievedDeckleValue] = useState(0);


    const [errorMessage, setErrorMessage] = useState('');
    const [shiftdate_errorMessage, setshiftdate_errorMessage] = useState('');

    const [viewWinderParentRollDetail, setviewWinderParentRollDetail] = useState(false);
    const [viewWinderDifferendParentRollDetail, setviewWinderDifferendParentRollDetail] = useState(false);
    const [viewWinderParentRollPlanningDetail, setviewWinderParentRollPlanningDetail] = useState(false);
    const [viewWinderParentRollSummaryDetail, setviewWinderParentRollSummaryDetail] = useState(false);
    const [viewParentRollList, setviewParentRollList] = useState(true);
    const [viewQRCodeDetails, setViewQRCodeDetails] = useState(false);
    const [viewAchievementSummary, setviewAchievementSummary] = useState(false);

    const [setwiseChildrollDetail, setSetwiseChildrollDetail] = useState([]);
    const [setNumberList, setSetNumberList] = useState([]);
    const [getChildReelAchievement, setgetChildReelAchievement] = useState([]);
    const [selectedSetNumberStatus, SetSelectedSetNumberStatus] = useState(null);
    const [selectedDuplicateSetNumberStatus, setSelectedDuplicateSetNumberStatus] = useState(null);
    const [setChildRollsDetails, setSetChildRollsDetails] = useState([]);
    const [selectedLot, setSelectedLot] = useState([]);

    // approved Child roll number list 
    const [approvedChildRollNumber, setApprovedChildRollNumber] = useState([]);
    const [selectedApprovedChildRollNumber, setSelectedApprovedChildRollNumber] = useState(null);

    // State for the QR code value
    const [qrCodeValue, setQRCodeValue] = useState('Netique infotech');

    const [selectedChildRollDetails, setSelectedChildRollDetails] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    // create date range
    const [dateRange, setDateRange] = useState({ from: '', to: '' });

    // table data view 
    const sizecolumns = ['ReelWidth', 'Width', 'Length', 'Order.Qty', 'Produced.Qty', 'Balance.Qty', 'Lineno'];
    const [createChildBtnDisapled, setCreateChildBtnDisapled] = useState(false);

    // reject reason
    const [rejectReason, setRejectReason] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [rejectProductType, setRejectProductType] = useState(null);
    const [rejectStatus, setRejectStatus] = useState(false);
    const [rejectReasonID, setRejectReasonID] = useState(0);
    const [rejectRemarks, setRejectRemarks] = useState(null);
    const [enableReject, setEnableReject] = useState(false);

    // OPERATORS
    const [operator, setOperator] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [selectedOperatorID, setSelectedOperatorID] = useState([]);
    const [selectedOperatorName, setSelectedOperatorName] = useState([]);
    const [isOperatorDataLoaded, setIsOperatorDataLoaded] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openPOPUP, setOpenPOPUP] = useState(false);
    const [getRejectResult, setGetRejectResult] = useState([]);
    const [openBreak, setOpenBreak] = useState(false);
    const [lotsDetail, setLotsDetail] = useState([]);
    const [diffLotsDetail, setDiffLotsDetail] = useState([]);

    const [isExtraSetModalOpen, setIsExtraSetModalOpen] = useState(false);
    const [isTransferReelModalOpen, setIsTransferReelModalOpen] = useState(false);

    const [callRefresh, setCallRefresh] = useState(false);
    const [selectedProductDetails, setSelectedProductDetails] = useState([]);
    const userPermissions = useUserPermissions();

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Winder Machine Production');
    const openFirst = Boolean(anchorElFirst);

    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [selectedStatus, setSelectedStatus] = useState('All');
    const [selectedButton, setSelectedButton] = useState(null);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [moHdrDetail, setMOHdrDetail] = useState([]);
    const [selectedMOs, setSelectedMOs] = useState([]);
    const [selectedMO, setSelectedMO] = useState('');
    const [partyList, setPartyList] = useState([]);

    const [selectedSetID, setSelectedSetID] = useState([]);
    const [setLength, setSetLength] = useState(0);
    const [diffSetLength, setDiffSetLength] = useState(0);
    const [actualSetLength, setActualSetLength] = useState(0);
    const [actualSetQty, setActualSetQty] = useState(0);
    const [sharedLength, setSharedLength] = useState(0);
    const [sharedQty, setSharedQty] = useState(0);
    const [callrefreshval, setCallRefreshval] = useState(false);
    const [enableReverse, setEnableReverse] = useState(true);
    const [selectedCore, setSelectedCore] = useState(0);
    const [setDiameter, setSetDiameter] = useState(0);

    const [selectedcombination, setSelectedCombination] = useState([]);
    const [availableLot, setAvailableLot] = useState([]);
    const [combinationStatus, setCombinationStatus] = useState(false);

    const [setWeight, setSetWeight] = useState(0);
    const [setWeightWithTrim, setSetWeightWithTrim] = useState(0);
    const [sharedSetWeightWithTrim, setSharedSetWeightWithTrim] = useState(0);
    const [totalJoints, setTotalJoints] = useState(0);
    const [jointParentRoll, setJointParentRoll] = useState(false);
    const [viewWinderJobList, setViewWinderJobList] = useState(true);
    const [addNewJob, setAddNewJob] = useState(true);
    const [refreshSetWeight, setRefreshSetWeight] = useState(false);
    const [setRemarks, setSetRemarks] = useState('');

    const [selectedParentRollLot, setSelectedParentRollLot] = useState([]);
    const [parentRollDate, setParentRollDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [result, setresult] = useState([]);

    //List Out WIP Reels
    const [openWipReelDetails, setOpenWipReelDetails] = useState(false);

    const handleOpenWipReelDetails = () => {
        setOpenWipReelDetails(true);
    };

    const handleCloseWipReelDetails = () => {
        setOpenWipReelDetails(false);
    };

    // hooks call
    const { actualSetCount, setActualCount, loadActualSetCount, } = useGetActualSetCount();

    let duplicateNextSet = (selectedcombination?.[0]?.sets ?? 0) + 1;

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'Winder Machine Production') {
            setSelectedStatus('All');
        }
        else if (option === 'Inprogress Parent Roll') {
            setSelectedStatus('booked');
        }
        else if (option === 'Cancelled Parent Roll') {
            setSelectedStatus('cancelled');
        }
        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };


    // call edit process
    useEffect(() => {
        setPeriod('All')
    }, [editParentRollID]);

    // IF SELECT PARENT ROLL NUMBE OR CHANGE THEN REFRESH PREVIOUS DATA event,
    const [refreshData, setRefreshData] = useState(false);

    const handleSelectParentRollNumber = async (event, value) => {
        await handleSelectParentRollNumberchange(value);
        setRefreshData(value);
    };

    const handleSelectParentRollNumberchange = async (value) => {

        const resetState = () => {
            setSelectedParentRollNumber(null);
            setLotsDetail([]);
            setSetNumberList([]);
            setSetChildRollsDetails([]);
            setviewParentRollList(false);
            setviewWinderParentRollDetail(false);
            setviewWinderParentRollPlanningDetail(false);
            setviewWinderParentRollSummaryDetail(false);
            setSelectedCombination([]);
            setJointParentRoll(false);
            setDiffParentRollNumbers([]);
            setDiffLotsDetail([]);
            setviewWinderDifferendParentRollDetail(false);
            setSelectedDiffParentRollNumber([]);

            // reset set wight values
            setSheetCounts([]);
            setSetLength(0);
            setSetWeight(0);
            setSharedLength(0);
            setSharedQty(0);
            setTotalJoints(0);
            setSetWeightWithTrim(0);
            setSharedSetWeightWithTrim(0);
            setActualNoOfSheetsProduced(0);

        };

        if (value) {
            // When a valid value is selected
            setSelectedParentRollNumber(value);
            LoadSelectedLotDetails(value.pr_number, 'new');
            setSelectedCombination([]);
            setJointParentRoll(false);
            setDiffParentRollNumbers([]);
            setDiffLotsDetail([]);
            setviewWinderDifferendParentRollDetail(false);
            setSelectedDiffParentRollNumber([]);

            // reset set wight values
            setSheetCounts([]);
            setSetLength(0);
            setSetWeight(0);
            setSharedLength(0);
            setSharedQty(0);
            setTotalJoints(0);
            setSetWeightWithTrim(0);
            setSharedSetWeightWithTrim(0);
            setActualNoOfSheetsProduced(0);
        } else {
            // When no value or an invalid value is selected
            resetState();
        }
    };


    // call load lot-details based on process
    const LoadSelectedLotDetails = (parentRoll, status) => {

        // Prepare the order data from localStorage and parameters
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_pr_number: parentRoll,
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {

                if (data?.length > 0) {
                    setParentRollDetails(data[0]);
                    setLotsDetail(data);
                    updateParentRollDetails(data[0]);
                    setParentRollDate(data[0].pr_date);

                    if (status === 'new') {
                        // Handle new status
                        setviewWinderParentRollDetail(true);
                        setviewWinderParentRollPlanningDetail(false);
                        setviewWinderParentRollSummaryDetail(false);
                    } else {

                        // Handle new status
                        const selectedRow = data.find(
                            (lot) =>
                                lot.release_no === String(winderMONumber) && // If release_no matches as a string
                                lot.lot_no === parseInt(winderMANumber)     // If lot_no matches as a number
                        );
                        if (selectedRow) {
                            handleEdit(selectedRow);
                        }
                    }

                }
            })
            .catch(error => { alert(error.message); });
    }


    // load - differend parent roll details
    const handleSelectDifferendParentRollNumber = (event, value) => {
        if (value !== undefined && value !== null && value.length > 0) {
            setSelectedDiffParentRollNumber(value);

            const selectedMonos = value.map((item) => item.pr_number);
            LoadSelectedLDiffrendParentRollLotDetailsRefresh(selectedMonos);

        }
        else {


            setDiffLotsDetail([]);
            setSelectedDiffParentRollNumber([]);
            setviewWinderDifferendParentRollDetail(false);
            setSetLength(actualSetLength);
            setDiffSetLength(0);
        }
    }


    // call differend parent roll lot details
    const LoadSelectedLDiffrendParentRollLotDetailsRefresh = (parentRoll) => {

        // Collect the values of the controls
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_parentroll_number: parentRoll,
            p_release_no: winderMONumber,
            p_lot_no: winderMANumber
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DIFF_PARENT_ROLL_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {

                    setDiffLotsDetail(data);

                    let differend_lot_length = data.reduce((sum, item) => sum + (item.reel_length || 0), 0);
                    setDiffSetLength(differend_lot_length);
                    differend_lot_length = differend_lot_length + actualSetLength;
                    setAvailableSetLength(differend_lot_length);
                    setSetLength(differend_lot_length);

                    setRefreshSetWeight((prev) => !prev);
                    setviewWinderDifferendParentRollDetail(true);

                }
            })
            .catch(error => { alert(error.message); });

    }


    const updateParentRollDetails = (data) => {
        // load mo number details
        setWinderMONumber(data.release_no);
        setWinderMANumber(data.lot_no);
        setWinderTotalSets(data.set_no);
        setWinderRemarks(data.remarks);
        setWinderBulk(0.689);
        setWinderOperators('Opreator1');
    };



    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                        setWinderShiftCode(data[0]);
                        setWinderShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    const handleWinderShiftChange = (event, value) => {
        if (value !== undefined && value !== null) {
            setWinderShiftCode(value);
            setWinderShiftID(value.shiftid);
        }
    }

    // Get Operator
    useEffect(() => {
        if (!isOperatorDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperator(data);
                        setSelectedOperator(data[0]);
                        setSelectedOperatorName(data[0].operator_code);
                        setWinderOperators(data[0].operator_code);
                        setSelectedOperatorID(data[0].id);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isOperatorDataLoaded]);


    const handleOperatorChange = (event, value) => {
        if (value !== undefined && value !== null) {
            setSelectedOperator(value);
            setSelectedOperatorName(value.operator_code);
            setWinderOperators(value.operator_code);
            setSelectedOperatorID(value.id);
        }

    }

    const handleAddSetWiseProductionDetail = () => {

        // Collect the values of the controls

        let itsvalid = true;
        let errmsg = "";
        setOpen(false);
        setSetChildRollsDetails(null);
        setSetNumberList(null);
        SetSelectedSetNumberStatus(null);

        if (winderShiftID === 0) {
            itsvalid = false;
            errmsg = "Please Select Shift Code";
        }

        if (itsvalid) {

            // create child roll number
            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_pr_number: selectedParentRollNumber.pr_number,
                p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
                p_shift_id: winderShiftID,
                p_user_name: selectedOperatorName,
                p_release_no: winderMONumber,
                p_lot_no: winderMANumber,

            };

            // create child rolls
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setSetwiseChildrollDetail(data);
                        get_SelectedLotNumber_status(data);
                        setviewWinderParentRollPlanningDetail(true);
                    }
                })
                .catch(error => {
                    // alert(error.message);
                    setseverityvalue('error');
                    setmessageValue('No data Found. Please check Submit value!');
                    setAlertTitleValue('Error');
                    setOpen(true);
                });



            // load already update child reel details
            setviewWinderParentRollSummaryDetail(false);
            const orderDataFilter = {
                p_companyid: localStorage.getItem('companyid'),
                p_pr_number: selectedParentRollNumber.pr_number,
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVEMENTS, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                .then(data => {
                    if (data && data.length > 0) {
                        setgetChildReelAchievement(data);
                        // console.log('selected Achievement Details', data);
                        setviewWinderParentRollSummaryDetail(true);
                    }
                })
                .catch(error => {
                    // alert(error.message);
                    alert(error.message);
                });


            // get Approved Child Roll List      
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                .then(data => {
                    if (data && data.length > 0) {
                        setApprovedChildRollNumber(null);
                        setApprovedChildRollNumber(data);
                        // console.log('selected Achievement Details', data);
                    }
                })
                .catch(error => {
                    // alert(error.message);
                    alert(error.message);
                });

        }

        else {
            setseverityvalue('error');
            setmessageValue(errmsg);
            setAlertTitleValue('Error');
            setOpen(true);
        }
    }



    const handleSelectLotNumberStatus = (event, value) => {

        if (value !== undefined && value !== null) {
            SetSelectedSetNumberStatus(value);
            setSelectedDuplicateSetNumberStatus(value);
            RefreshLotData(value);
        }
        else { setSetChildRollsDetails([]); }

    };


    // amend process






    const handleSelectLotNumberStatusID = (event, value) => {

        if (value !== undefined && value !== null) {
            setSelectedSetID(value);
        }
    };


    // update selected set child roll number
    useEffect(() => {

        if (selectedSetNumberStatus !== 0 && selectedSetNumberStatus !== null) {


            const orderDataFilter = {
                p_companyid: localStorage.getItem('companyid'),
                p_pr_number: selectedParentRollNumber.pr_number,
                p_release_no: winderMONumber,
                p_lot_no: winderMANumber,
                p_set_no: selectedSetNumberStatus.setid,
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST_USING_SET, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                .then(reelAchievements => {
                    if (reelAchievements?.length > 0) {
                        setApprovedChildRollNumber(reelAchievements);
                    }
                    else {
                        setApprovedChildRollNumber([]);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [selectedSetNumberStatus]);


    const RefreshLotData = (value) => {

        let selected_Lot_Number = value.setid;
        setSetChildRollsDetails([]);
        if (setwiseChildrollDetail.length > 0) {
            const filteredChildRollsDetails = setwiseChildrollDetail
                .filter(detail => detail.setid === selected_Lot_Number)
                .sort((a, b) => a.id - b.id);

            // Check if all rows have the status "approved"
            const allApproved = filteredChildRollsDetails.every(detail => detail.status === 'approved');

            // Set enableReverse based on whether all statuses are approved
            if (allApproved) { setEnableReverse(false); } else { setEnableReverse(true); }

            const booked = filteredChildRollsDetails.find(detail => {
                // console.log("Checking: ", detail.status);
                return detail.status.toLowerCase() === 'booked' || detail.status.toLowerCase() === 'wip';
            });

            // Update the state with the filtered chi   ld rolls details
            setSetChildRollsDetails(filteredChildRollsDetails);

            if (booked) { setCreateChildBtnDisapled(false); } else { setCreateChildBtnDisapled(true); }
            setViewQRCodeDetails(false);
            setviewAchievementSummary(false);
            setSelectedApprovedChildRollNumber(null);
        }
    };


    const get_SelectedLotNumber_status = (data) => {

        const uniqueSetNumbers = data.reduce((acc, currentValue) => {
            const { setid } = currentValue;
            const key = `${setid}`;
            if (!acc[key]) {
                acc[key] = { setid };
            }
            return acc;
        }, {});

        // Convert the object values back to an array
        const uniqueSetNumberList = Object.values(uniqueSetNumbers);
        // Update the state with the filtered set numbers
        setSetNumberList(uniqueSetNumberList);


    };

    const updateLotSizeChanges = (newRows) => {
        setSetChildRollsDetails(newRows);
    };

    // update Production Quantity in child roll wise
    const updateChildRollDetails = async () => {


        try {
            await UpdateChildRollDetail(
                open,
                setOpen,
                severityvalue,
                setseverityvalue,
                messageValue,
                setmessageValue,
                alertTitleValue,
                setAlertTitleValue,
                selectedParentRollNumber.pr_number,
                setChildRollsDetails,
                get_SelectedLotNumber_status,
                setSetwiseChildrollDetail,
                setApprovedChildRollNumber,
                setgetChildReelAchievement,
                createChildBtnDisapled,
                setCreateChildBtnDisapled,
                winderMONumber,
                winderMANumber,
                shiftDate,
                winderShiftCode
            );

            // These lines will only run after UpdateChildRollDetail finishes
            setviewWinderParentRollSummaryDetail(true);
            setCallRefresh(true);
            handleSelectLotNumberStatus(selectedSetNumberStatus, selectedSetNumberStatus);
        } catch (error) {
            console.error("Error in updateChildRollDetails:", error);
        }

    };


    // Reverse Approved Reel Details
    const reverseChildRollDetails = () => {
        ReverseChildRollDetail(open, setOpen, severityvalue, setseverityvalue, messageValue, setmessageValue, alertTitleValue, setAlertTitleValue, selectedParentRollNumber.pr_number, setChildRollsDetails, get_SelectedLotNumber_status, setSetwiseChildrollDetail, setApprovedChildRollNumber, setgetChildReelAchievement, createChildBtnDisapled, setCreateChildBtnDisapled, winderMONumber, winderMANumber);
        setviewWinderParentRollSummaryDetail(true);
    };

    // load selected child reel number
    const handleChildRollNumebrChange = (event, value) => {

        if (value === null || value === 'undefined') {
            setSelectedApprovedChildRollNumber(null);
            setViewQRCodeDetails(false);
        }
        else {
            setSelectedApprovedChildRollNumber(value);
            LoadChildRollDetailsInQRCode(1, value.child_reel_number, viewQRCodeDetails, setViewQRCodeDetails, setSelectedChildRollDetails, setQRCodeValue)
            ChildRollProductDetail(value.child_reel_number);
            setviewAchievementSummary(false);
        }

    };

    const callback = () => {
        handleBackWinderMachineEntry();
    };

    useEffect(() => {
        filterData('All'); // Initial load with 'All' filter
    }, []);

    const filterData = async (filter) => {
        setDateRange({ from: '', to: '' }); // Clear existing date range
        let fromDate, toDate;
        switch (filter) {
            case 'All':
                fromDate = dayjs().subtract(4, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'Today':
                fromDate = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Week':
                fromDate = dayjs().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('week').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Month':
                fromDate = dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Quarter':
                fromDate = dayjs().startOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Year':
                fromDate = dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                fromDate = ''; // You can set a default value here
                toDate = ''; // You can set a default value here
                break;
        }
        setDateRange({ from: fromDate, to: toDate });

        RefreshOldSelectedData();
        //GetDateRange(filter, dateRange, setDateRange);
        if (fromDate != '') {
            // Now you can use the updated dateRange state
            //LoadParentRollList(fromDate, toDate, setparentRollNumbers, viewParentRollList, setviewParentRollList, viewWinderParentRollDetail, setviewWinderParentRollDetail, viewWinderParentRollPlanningDetail, setviewWinderParentRollPlanningDetail, viewWinderParentRollSummaryDetail, setviewWinderParentRollSummaryDetail);

        }
    };


    const RefreshOldSelectedData = () => {
        setparentRollNumbers([]);
        setSelectedParentRollNumber(null);
        setLotsDetail([]);
        setSetNumberList([]);
        setSetChildRollsDetails([]);
        setviewParentRollList(false);
        setviewWinderParentRollDetail(false);
        setviewWinderParentRollPlanningDetail(false);
        setviewWinderParentRollSummaryDetail(false);
        setviewWinderDifferendParentRollDetail(false);
        setSelectedCombination([]);
        setJointParentRoll(false);
        setDiffParentRollNumbers([]);
        setSelectedDiffParentRollNumber(null);
    }


    useEffect(() => {

        if (parentRollNumbers.length > 0 && editParentRollID !== '') {

            const selected = parentRollNumbers.find(party => party.pr_number === editParentRollID);
            if (selected) {
                setSelectedParentRollNumber(selected);
            }

            const p_companyid = localStorage.getItem('companyid');
            const p_parent_roll_number = editParentRollID;

            // Collect the values of the controls
            const orderData = {
                p_companyid,
                p_pr_number: p_parent_roll_number,

            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {

                        setParentRollDetails(data[0]);
                        setLotsDetail(data);
                        updateParentRollDetails(data[0]);
                        setviewWinderParentRollDetail(true);
                        setviewWinderParentRollPlanningDetail(false);
                        setviewWinderParentRollSummaryDetail(false);

                        if (moHdrDetail.length > 0) {
                            const select_mo_number = moHdrDetail.find(hdr => hdr.mono === data[0].release_no);
                            if (select_mo_number) {
                                setSelectedMOs([select_mo_number]);
                            }
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }

    }, [parentRollNumbers])


    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleOpenExtraSetModal = () => {
        setIsExtraSetModalOpen(true);
    };

    const [headerData, setheaderData] = useState({
        logo: process.env.PUBLIC_URL + '/ITC_logo.png',
    });

    function formatDate(dateString) {
        if (!dateString) return ''; // Handle null or undefined date
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits for day
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits for month
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`;
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);

        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
        }
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setOperator(data);
                    setSelectedOperator(data[0]);
                    setSelectedOperatorName(data[0].operator_code);
                    setWinderOperators(data[0].operator_code);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    };

    const handleCloseExtraSet = async () => {
        setIsExtraSetModalOpen(false);
        await handleSelectParentRollNumberchange(selectedParentRollNumber);
        let row = selectedParentRollLot[0];
        await handleEdit(row);

    }
    const handleCancelExtraSet = async () => {
        setIsExtraSetModalOpen(false);
        // await handleSelectParentRollNumberchange(selectedParentRollNumber);
        // let row = selectedParentRollLot[0];
        // await handleEdit(row);

    }

    const handleCloseReelTransferModal = () => {
        setIsTransferReelModalOpen(false);
    }


    const handleButtonClick = async (buttonName) => {

        setSelectedButton(buttonName);
        setOpen(false);

        let reelDetails = approvedChildRollNumber;
        let isvalid = true;
        let company_id = localStorage.getItem('companyid');
        let mode = 1;

        if (approvedChildRollNumber.child_reel_number === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!selectedApprovedChildRollNumber || selectedApprovedChildRollNumber.master_reel === 'undefined')) {
            isvalid = false;

            setseverityvalue('info');
            setmessageValue('Please select reel code to print');
            setAlertTitleValue('info');
            setOpen(true);
        }

        // selectedChildRollDetails

        if (isvalid == true) {
            if (buttonName === "PrintQR") {
                reelDetails = approvedChildRollNumber.find(bundle => bundle.child_reel_number === selectedApprovedChildRollNumber.child_reel_number);
                reelDetails = reelDetails ? [reelDetails] : []; // Wrap bundleDetails in an array if it exists
            }

            const printWindow = window.open('', '_blank');
            try {
                // Generate HTML content for each QR code
                for (const qrCodeValue of reelDetails) {
                    // Generate QR code data URL
                    const qrDataUrl = await generateQRCode(qrCodeValue.child_reel_number);
                    // Check if QR code generation was successful
                    if (!qrDataUrl) {
                        console.error('Error generating QR code for value:', qrCodeValue.child_reel_number);
                        continue; // Skip to the next QR code
                    }

                    // Ensure reel_length is a 3-digit value
                    let reelLength = qrCodeValue.reel_length || 0;
                    reelLength = parseFloat(reelLength).toFixed(2); // Restrict to 3 decimal places

                    if (company_id === 1) {
                        // Write HTML content for the QR code to the print window
                        printWindow.document.write(`

                            <html>
                                <head>
                                    <title>Printed Report</title>
                                    <style>
                                        body {
                                            margin: 0;
                                            padding: 0;
                                            font-family: Arial, sans-serif;
                                        }
                                        .container {
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            padding: 10px;
                                            border: 1px solid #ccc;
                                            box-sizing: border-box;
                                        }
                                        .qr-code {
                                            width: 150px; /* Adjust as needed */
                                        }
                                        .bundle-details {
                                            flex: 1;
                                            margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                                        }
                                        .bundle-details h5 {
                                            margin: 0;
                                            font-size: 18px;
                                        }
                                        .details-table {
                                            display: grid;
                                            grid-template-columns: 150px auto;
                                            gap: 10px 20px;
                                            margin-top: 10px;
                                        }
                                        .details-table div {
                                            font-size: 16px;
                                        }
                                        .details-table .label {
                                            font-weight: bold;
                                        }
                                        .bundle-details hr {
                                            margin: 10px 0;
                                            border: 1px solid #ccc;
                                        }
                                        /* Ensure each container goes on a new page */
                                        .container {
                                            page-break-after: always;
                                        }
                                    </style>
                                </head>
                                <body>
                                    <div class="container">
                                        <div>
                                            <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                                            <h3>${qrCodeValue.child_reel_number || 'XXXXXX0123'}</h3>
                                        </div>

                                        <div class="bundle-details">
                                            <h5>CHILD REEL DETAILS</h5>
                                            <hr/>
                                            <div class="details-table">
                                                <div class="label">DATE / SHIFT </div><div>:  ${qrCodeValue.shift_date || ''} / ${qrCodeValue.shift_code || ''}</div> 
                                                <div class="label">REEL NUMBER</div><div>: ${qrCodeValue.child_reel_number}</div> 
                                                <div class="label">QUALITY</div><div>: ${qrCodeValue.item_code}</div> 
                                                <div class="label">SIZE</div><div>: ${qrCodeValue.width || '0'} X ${qrCodeValue.length}</div>  
                                                <div class="label">GSM</div><div>: ${qrCodeValue.gsm}</div> 
                                                <div class="label">REEL.WT (MT)</div><div>: ${qrCodeValue.achieved_qty}</div> 
                                                <div class="label">PARENT ROLL NO</div><div>: ${qrCodeValue.pr_number}</div> 
                                                <div class="label">MO NO</div><div>: ${qrCodeValue.mo_number}</div> 
                                                <div class="label">MA NO</div><div>: ${qrCodeValue.ma_number}</div> 
                                                <div class="label">SO NO</div><div>: ${qrCodeValue.indent_no}</div> 
                                                <div class="label">CUSTOMER NAME</div><div>: ${qrCodeValue.customer_name}</div> 
                                                <div class="label">REMARKS</div><div>: ${qrCodeValue.remarks}</div>
                                            </div>
                                        </div>
                                    </div>
                                </body>
                            </html>                       
                            
                        `);
                    }

                    // else if (company_id === '13') {


                    //     const fontSize = qrCodeValue.indent_no.split(",").length > 2 ? "10px" :
                    //         qrCodeValue.indent_no.includes(",") ? "14px" : "inherit";  // Adjust font size if more than one value



                    //     printWindow.document.write(`
                    //         <html>
                    //             <head>
                    //                 <title>Printed Report</title>
                    //                 <style>
                    //                     @page {
                    //                             size: 100mm 150mm; /* Portrait orientation */
                    //                             margin: 0; /* Remove margins for edge-to-edge printing */
                    //                     }
                    //                     body {
                    //                             margin-left: 1mm;
                    //                             padding: 0;
                    //                             font-family: Arial, sans-serif;
                    //                             display: flex;
                    //                             flex-direction: column;
                    //                             align-items: flex-start;
                    //                             justify-content: flex-start;
                    //                             box-sizing: border-box;
                    //                     }
                    //                     .labelx {
                    //                             width: 100mm;
                    //                             height: 150mm;
                    //                             /*padding: 3mm;*/
                    //                             box-sizing: border-box;
                    //                             /*border: 1px solid #000;*/
                    //                             display: flex;
                    //                             flex-direction: column;
                    //                             justify-content: space-between;

                    //                     }                               

                    //                     .container {
                    //                         width: 100%;
                    //                         height: 100%;                                
                    //                         box-sizing: border-box;
                    //                     }
                    //                     .header {
                    //                         display: flex;
                    //                         align-items: center;                                    
                    //                     }
                    //                     .header img {
                    //                         width: 20mm;
                    //                         height: auto;
                    //                         margin-right: 10mm;
                    //                     }
                    //                     .company-details h4 {
                    //                         font-weight: bold;
                    //                         color: #01579b;
                    //                         margin: 0;
                    //                         font-size: 12px;
                    //                     }
                    //                     .marketed-by {
                    //                         text-align: center; /* Aligns all text in this div to the center */
                    //                     }
                    //                     .divider {
                    //                         width: 100%; /* Full width of the container */
                    //                         height: 1px; /* Thin line for the divider */
                    //                         background-color: #000; /* Black color for visibility */
                    //                         margin: 10px 0; /* Spacing above and below */
                    //                     }
                    //                     .details-table {
                    //                         width: 100%;
                    //                         border-collapse: collapse;

                    //                         font-size: 15px;
                    //                     }
                    //                     .details-table th, .details-table td {
                    //                         padding: 2mm;
                    //                         text-align: left;
                    //                         border: 1px solid #ccc;

                    //                         font-weight: bold;
                    //                     }
                    //                     .details-table th {
                    //                         background-color: #f2f2f2;
                    //                         font-weight: bold;
                    //                     }
                    //                     .qr-code-container {
                    //                         text-align: center;
                    //                         margin-top: 5mm;
                    //                     }
                    //                     .qr-code-container img {
                    //                         width: 30mm;
                    //                         height: auto;
                    //                     }
                    //                     .qr-code-container h3 {
                    //                         font-weight: bold;
                    //                         font-size: 12px;
                    //                         margin: 5mm 0 0 0;
                    //                     }
                    //                     .footer {
                    //                         text-align: center;
                    //                         margin-top: 5mm;
                    //                         font-size: 14px;
                    //                         font-weight: bold;

                    //                     }
                    //                     .title {
                    //                         text-align: center;
                    //                         margin-top: 40mm;
                    //                         font-size: 10px;
                    //                         font-weight: bold;

                    //                     }   
                    //                          .title1 {
                    //                         text-align: center;
                    //                         margin-top: 50mm;
                    //                         font-size: 10px;
                    //                         font-weight: bold;

                    //                     }    

                    //                 </style>
                    //             </head>
                    //             <body>
                    //                 <div class="labelx">
                    //                     <div class="container">                                
                    //                         <!-- Header -->
                    //                     <div class="title">
                    //                             <h2>REEL CARD </h2>
                    //                         </div> 

                    //                         <!-- Product Details Table -->
                    //                         <table class="details-table">
                    //                             <tr>
                    //                                 <th style="font-weight: bold;">DATE</th>
                    //                                 <td>${formatDate(qrCodeValue.shift_date)}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>REEL NO</th>
                    //                                 <td>${qrCodeValue.child_reel_number}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>JUMBO NO</th>
                    //                                 <td>${qrCodeValue.pr_number}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>PRODUCT</th>
                    //                                 <td>${qrCodeValue.item_code}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th style="font-weight: bold;" >GSM</th>
                    //                                 <td>${qrCodeValue.gsm}</td>
                    //                             </tr>
                    //                              <tr>
                    //                                 <th style="font-weight: bold;">REEL SIZE (CM)</th>
                    //                                 <td>${qrCodeValue.master_reel || '0'}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th style="font-weight: bold;">CUSTOMER SIZE (CM)</th>
                    //                                <td>
                    //                                     ${qrCodeValue.length === 0
                    //                                     ? qrCodeValue.width || '0'
                    //                                     : `${qrCodeValue.width || '0'} X ${qrCodeValue.length || '0'}`}
                    //                                 </td>

                    //                             </tr> 
                    //                             <tr>
                    //                                 <th style="font-weight: bold;">LENGTH (M)</th>
                    //                                 <td>${Math.floor(qrCodeValue.reel_length) || '0'}</td>
                    //                             </tr>                                        
                    //                             <tr>
                    //                                 <th>NET WEIGHT (KG)</th>
                    //                                 <td>${(qrCodeValue.achieved_qty) * 1000}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>ORDER NO</th>
                    //                                 <td style="font-size: ${fontSize};">
                    //                                     ${qrCodeValue.indent_no}
                    //                                 </td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>REMARKS</th>
                    //                                 <td style="font-size:8px;">${(qrCodeValue.remarks || '')}</td>
                    //                             </tr>

                    //                             <!-- Conditionally Add GROSS WEIGHT Row -->
                    //                             ${mode === 0 ? `
                    //                                 <tr>
                    //                                     <th>GROSS WEIGHT (KG)</th>
                    //                                     <td>${(qrCodeValue.gross_qty) * 1000}</td>
                    //                                 </tr>
                    //                             ` : ''}


                    //                         </table>            


                    //                         <!-- Footer Section -->
                    //                         ${mode === 0 ? `
                    //                         <div class="footer">
                    //                             <h2>MADE IN INDIA</h2>
                    //                         </div>    
                    //                         ` : ''}            
                    //                     </div>
                    //                 </div>
                    //                   <div class="labelx">
                    //                     <div class="container">                                
                    //                         <!-- Header -->
                    //                     <div class="title">
                    //                             <h2>REEL CARD </h2>
                    //                         </div> 

                    //                         <!-- Product Details Table -->
                    //                         <table class="details-table">
                    //                             <tr>
                    //                                 <th style="font-weight: bold;">DATE</th>
                    //                                 <td>${formatDate(qrCodeValue.shift_date)}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>REEL NO</th>
                    //                                 <td>${qrCodeValue.child_reel_number}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>JUMBO NO</th>
                    //                                 <td>${qrCodeValue.pr_number}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>PRODUCT</th>
                    //                                 <td>${qrCodeValue.item_code}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th style="font-weight: bold;" >GSM</th>
                    //                                 <td>${qrCodeValue.gsm}</td>
                    //                             </tr>
                    //                              <tr>
                    //                                 <th style="font-weight: bold;">REEL SIZE (CM)</th>
                    //                                 <td>${qrCodeValue.master_reel || '0'}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th style="font-weight: bold;">CUSTOMER SIZE (CM)</th>
                    //                                 <td>
                    //                                     ${qrCodeValue.length === 0
                    //                                     ? qrCodeValue.width || '0'
                    //                                     : `${qrCodeValue.width || '0'} X ${qrCodeValue.length || '0'}`}
                    //                                 </td>
                    //                             </tr> 
                    //                             <tr>
                    //                                 <th style="font-weight: bold;">LENGTH (M)</th>
                    //                                 <td>${Math.floor(qrCodeValue.reel_length) || '0'}</td>
                    //                             </tr>                                        
                    //                             <tr>
                    //                                 <th>NET WEIGHT (KG)</th>
                    //                                 <td>${(qrCodeValue.achieved_qty) * 1000}</td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>ORDER NO</th>
                    //                                   <td style="font-size: ${fontSize};">
                    //                                     ${qrCodeValue.indent_no}
                    //                                 </td>
                    //                             </tr>
                    //                             <tr>
                    //                                 <th>REMARKS</th>
                    //                                 <td style="font-size: 8px;">${(qrCodeValue.remarks || '')}</td>
                    //                             </tr>

                    //                             <!-- Conditionally Add GROSS WEIGHT Row -->
                    //                             ${mode === 0 ? `
                    //                                 <tr>
                    //                                     <th>GROSS WEIGHT (KG)</th>
                    //                                     <td>${(qrCodeValue.gross_qty) * 1000}</td>
                    //                                 </tr>
                    //                             ` : ''}


                    //                         </table>            


                    //                         <!-- Footer Section -->
                    //                         ${mode === 0 ? `
                    //                         <div class="footer">
                    //                             <h2>MADE IN INDIA</h2>
                    //                         </div>    
                    //                         ` : ''}            
                    //                     </div>
                    //                 </div>

                    //             </body>
                    //         </html>
                    //     `);
                    // }

                    else if (company_id === '13') {


                        const fontSize = qrCodeValue.indent_no.split(",").length > 2 ? "12px" :
                            qrCodeValue.indent_no.includes(",") ? "18px" : "inherit";  // Adjust font size if more than one value

                        let packagemode = '';
                        let ordertype = qrCodeValue.order_type;
                        let numberofsheets = '';
                        if (qrCodeValue.number_of_sheets && qrCodeValue.number_of_sheets > 0) {
                            numberofsheets = ' - ' + qrCodeValue.number_of_sheets;
                        }

                        if (qrCodeValue.package_type === 'BDL' || qrCodeValue.package_type === 'BUNDLE') {
                            packagemode = 'BUNDLE / ' + ordertype + numberofsheets;
                        }
                        else if (qrCodeValue.package_type === 'BP' || qrCodeValue.package_type === 'BULK ON PALLET') {
                            packagemode = 'BULK ON PALLET / ' + ordertype + numberofsheets;
                        }
                        else if (qrCodeValue.package_type === 'RL') {
                            packagemode = 'REEL / ' + ordertype + numberofsheets;
                        }
                        else {
                            packagemode = qrCodeValue.package_type + ' / ' + ordertype + numberofsheets;
                        }

                        printWindow.document.write(`
                           <html>
                            <head>
                                <title>Printed Report</title>
                                <style>
                                    @page {
                                            size: 100mm 150mm; /* Portrait orientation */
                                            margin: 0; /* Remove margins for edge-to-edge printing */
                                    }
                                    body {
                                            margin-left: 1mm;
                                            padding: 0;
                                            font-family: Arial, sans-serif;
                                            display: flex;
                                            flex-direction: column;
                                            align-items: flex-start;
                                            justify-content: flex-start;
                                            box-sizing: border-box;
                                    }
                                    .labelx {
                                            width: 100mm;
                                            height: 150mm;
                                            /*padding: 3mm;*/
                                            box-sizing: border-box;
                                            /*border: 2px solid #000;*/
                                            display: flex;
                                            flex-direction: column;
                                            justify-content: space-between;
                                        
                                    }                               
                                
                                    .container {
                                        width: 100%;
                                        height: 100%;                                
                                        box-sizing: border-box;
                                    }
                                    .header {
                                        display: flex;
                                        align-items: center;                                    
                                    }
                                    .header img {
                                        width: 20mm;
                                        height: auto;
                                        margin-right: 10mm;
                                    }
                                    .company-details h4 {
                                        font-weight: bold;
                                        color: #01579b;
                                        margin: 0;
                                        font-size: 12px;
                                    }
                                    .marketed-by {
                                        text-align: center; /* Aligns all text in this div to the center */
                                    }
                                    .divider {
                                        width: 100%; /* Full width of the container */
                                        height: 1px; /* Thin line for the divider */
                                        background-color: #000; /* Black color for visibility */
                                        margin: 10px 0; /* Spacing above and below */
                                    }
                                    .details-table {
                                        width: 100%;
                                        border-collapse: collapse; /* removes double borders */
                                        font-size: 13px;
                                    }
                                    .details-table th, .details-table td {
                                        border: 1px solid black;   /* single clean border */
                                        padding: 4px;
                                        text-align: center;        /* align like sample */
                                        font-weight: bold;
                                        
                                    }
                                    .details-table th {
                                        background: white;         /* remove grey */
                                        text-transform: uppercase; /* matches sample */
                                    }
                                    .details-table td {
                                        padding: 2mm;
                                        text-align: left;
                                        
                                        font-weight: bold;
                                        word-wrap: break-word; /* Ensures long words are wrapped */
                                        white-space: normal; /* Allows text to break into multiple lines */
                                        max-width: 50mm; /* Adjust based on your label size */
                                    }    
                                    .qr-code-container {
                                        text-align: center;
                                        margin-top: 5mm;
                                    }
                                    .qr-code-container img {
                                        width: 30mm;
                                        height: auto;
                                    }
                                    .qr-code-container h3 {
                                        font-weight: bold;
                                        font-size: 12px;
                                        margin: 5mm 0 0 0;
                                    }
                                    .footer {
                                        text-align: center;
                                        margin-top: 5mm;
                                        font-size: 14px;
                                        font-weight: bold;
                                    
                                    }
                                    .title {
                                        text-align: center;
                                    
                                        font-size: 10px;
                                        font-weight: bold;
                                    
                                    }   
                                        .title1 {
                                        text-align: center;
                                    
                                        font-size: 10px;
                                        font-weight: bold;
                                    
                                    }    
                                        
                                </style>
                            </head>
                            <body>
                                <div class="labelx">
                                    <div class="container">                                
                                        <!-- Header -->
                                    <div class="title">
                                            <h2>REEL PROCESS CARD </h2>
                                        </div> 

                                        <!-- Product Details Table -->
                                        <table class="details-table">
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">DATE</th>
                                                <td>${formatDate(qrCodeValue.shift_date)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">REEL NO</th>
                                                <td  style="font-size:30;font-weight: bold;">${qrCodeValue.child_reel_number}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">JUMBO NO</th>
                                                <td>${qrCodeValue.pr_number}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">PRODUCT</th>
                                                <td>${qrCodeValue.item_code}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold;  text-align: left" >GSM</th>
                                                <td>${qrCodeValue.gsm}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">REEL SIZE (CM)</th>
                                                <td>${qrCodeValue.master_reel || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">CUSTOMER SIZE </th>
                                            <td>
                                                    ${qrCodeValue.length === 0
                                ? qrCodeValue.width || '0'
                                : `${qrCodeValue.width || '0'} X ${qrCodeValue.length || '0'}`}
                                                </td>

                                            </tr> 
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">LENGTH (M)</th>
                                                <td>${Math.floor(qrCodeValue.reel_length) || '0'}</td>
                                            </tr>                                        
                                            <tr>
                                                <th style=" text-align: left">NET WEIGHT (KG)</th>
                                                <td>${(qrCodeValue.achieved_qty)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">ORDER NO</th>
                                                <td style="font-size: ${fontSize};">${(qrCodeValue.indent_no)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">MACHINE NO</th>
                                                <td style="font-size: ${fontSize};">${(qrCodeValue.machine)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">PACK MODE</th>
                                                <td style="font-size: ${fontSize};">${(packagemode)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">REMARKS</th>
                                                <td style="font-size: ${fontSize}; word-wrap: break-word; white-space: normal; max-width: 50mm;">${(qrCodeValue.remarks || '')}</td>
                                            </tr>

                                            <!-- Conditionally Add GROSS WEIGHT Row -->
                                            ${mode === 0 ? `
                                                <tr>
                                                    <th style=" text-align: left">GROSS WEIGHT (KG)</th>
                                                    <td>${(qrCodeValue.gross_qty)}</td>
                                                </tr>
                                            ` : ''}                                    
                                        
                                        </table> 
                                        
                                        </table>   
                                                <!-- NEW Pallate/Sheet/F.No/Ream Table -->
                                                <table class="details-table">
                                                    <thead>
                                                        <tr>
                                                        <th>Pallate</th>
                                                        <th>Sheet</th>
                                                        <th>F. No</th>
                                                        <th>Ream</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                        <td>A</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        </tr>
                                                        <tr>
                                                        <td>B</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        </tr>
                                                    </tbody>
                                                    </table>     
                                    

                                        <!-- Footer Section -->
                                        ${mode === 0 ? `
                                        <div class="footer">
                                            <h2>MADE IN INDIA</h2>
                                        </div>    
                                        ` : ''}            
                                    </div>
                                </div>
                                <div class="labelx">
                                    <div class="container">                                
                                        <!-- Header -->
                                    <div class="title">
                                            <h2>REEL PROCESS CARD</h2>
                                        </div> 

                                        <!-- Product Details Table -->
                                        <table class="details-table">
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">DATE</th>
                                                <td>${formatDate(qrCodeValue.shift_date)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">REEL NO</th>
                                                <td style="font-size:30;font-weight: bold;">${qrCodeValue.child_reel_number}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">JUMBO NO</th>
                                                <td>${qrCodeValue.pr_number}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">PRODUCT</th>
                                                <td>${qrCodeValue.item_code}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold; text-align: left" >GSM</th>
                                                <td>${qrCodeValue.gsm}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">REEL SIZE (CM)</th>
                                                <td>${qrCodeValue.master_reel || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">CUSTOMER SIZE </th>
                                                <td>
                                                    ${qrCodeValue.length === 0
                                ? qrCodeValue.width || '0'
                                : `${qrCodeValue.width || '0'} X ${qrCodeValue.length || '0'}`}
                                                </td>
                                            </tr> 
                                            <tr>
                                                <th style="font-weight: bold; text-align: left">LENGTH (M)</th>
                                                <td>${Math.floor(qrCodeValue.reel_length) || '0'}</td>
                                            </tr>                                        
                                            <tr>
                                                <th style=" text-align: left">NET WEIGHT (KG)</th>
                                                <td>${(qrCodeValue.achieved_qty)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">ORDER NO</th>
                                                <td style="font-size: ${fontSize};">${(qrCodeValue.indent_no)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">MACHINE NO</th>
                                                <td style="font-size: ${fontSize};">${(qrCodeValue.machine)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">PACK MODE</th>
                                                <td style="font-size: ${fontSize};">${(packagemode)}</td>
                                            </tr>
                                            <tr>
                                                <th style=" text-align: left">REMARKS</th>
                                                <td style="font-size: ${fontSize}; word-wrap: break-word; white-space: normal; max-width: 50mm;">${(qrCodeValue.remarks || '')}</td>
                                            </tr>

                                            <!-- Conditionally Add GROSS WEIGHT Row -->
                                            ${mode === 0 ? `
                                                <tr>
                                                    <th style=" text-align: left">GROSS WEIGHT (KG)</th>
                                                    <td>${(qrCodeValue.gross_qty)}</td>
                                                </tr>
                                            ` : ''}
                                        
                                        </table> 

                                        </table>   
                                                <!-- NEW Pallate/Sheet/F.No/Ream Table -->
                                                    <table class="details-table">
                                                    <thead>
                                                        <tr>
                                                        <th>Pallate</th>
                                                        <th>Sheet</th>
                                                        <th>F. No</th>
                                                        <th>Ream</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                        <td>A</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        </tr>
                                                        <tr>
                                                        <td>B</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        </tr>
                                                    </tbody>
                                                    </table>     
                                        

                                        <!-- Footer Section -->
                                        ${mode === 0 ? `
                                        <div class="footer">
                                            <h2>MADE IN INDIA</h2>
                                        </div>    
                                        ` : ''}            
                                    </div>
                                </div>
                                
                            </body>
                        </html>

                        `);
                    }

                }

                // Close the print window and print the report
                printWindow.document.close();
                printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }

        }

    };


    //     <!-- Header Section -->
    //     <div class="header">
    //         <img src="${headerData.logo}" alt="Logo" />
    //          <div>
    //             <h4 style="margin: 0; color: #01579b;">PAPERBOARDS</h4>
    //             <h4 style="margin: 0; color: #01579b;">AND</h4>
    //             <h4 style="margin: 0; color: #01579b;">SPECIALTY</h4>
    //             <h4 style="margin: 0; color: #01579b;">PAPERS DIVISION</h4>
    //          </div>
    //     </div>

    //     <div class="divider" style="width: 100%; height: 1px; background-color: #000; margin: 5px 0;"></div>

    //     <!-- Marketed By Information -->
    //    <div class="marketed-by" style="text-align: center;">
    //     <h6 style="margin: 0;">Marketed By:</h6>
    //     <h6 style="margin: 0;">ITC Limited</h6>
    //     <h6 style="margin: 0;">106, SP Road, Secunderabad</h6>
    //     <h6 style="margin: 0;">Telangana - 500003</h5>
    //     <h6 style="margin: 0;">Phone: 91-40-27846566-73</h6>
    //    </div>

    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };

    const openpopup = async (buttonName) => {
        setSelectedButton(buttonName);
        setOpenPOPUP(true);
    }

    const closepopup = () => {
        setOpenPOPUP(false);
    }

    const callRejectionProcess = () => {
        setOpenPOPUP(false);

        let reject_product_type = "ChildRoll";
        let product_code = selectedApprovedChildRollNumber.child_reel_number;
        let isvalid = true;

        if (product_code === "") {
            isvalid = false;
        }
        else if (selectedApprovedChildRollNumber.child_reel_number == "") {
            isvalid = false;
        }

        if (isvalid) {

            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_product_type: reject_product_type,
                p_product_code: product_code,
                p_reject_reason_id: rejectReasonID,
                p_reject_remark: rejectRemarks,
                p_user_id: 1,
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_PRODUCT_REJECTION, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        setGetRejectResult(data);
                        alert(`Child Roll Number ${product_code} was rejected Successfully`);
                        setCallRefresh(true);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    };



    const handleKeyPress = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'p') {
            handleButtonClick('PrintQR')
        }
        if (event.altKey && event.key.toLowerCase() === 'a') {
            handleButtonClick('PrintQRAll')
        }
        if (event.altKey && event.key.toLowerCase() === 'r') {
            openpopup('RejectChild')
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleButtonClick, handleButtonClick, openpopup]);


    const openBreakpopup = async (buttonName) => {
        setSelectedButton(buttonName);
        setOpenBreak(true);
    }

    const closeBreakpopup = () => {
        setOpenBreak(false);
    }


    useEffect(() => {
        if (setLength > 0) {
            handleAdjustReelLength(setLength);
            let mono = winderMONumber;
            let mano = winderMANumber;
            getParticularCombinationDetails(mono, mano, setLength);
        }
    }, [refreshSetWeight, setRefreshSetWeight])


    const [noLength, setNoLength] = useState(false);

    const handleEdit = async (row) => {

        let mono = row.release_no;
        let mano = row.lot_no;

        // selected lot detail
        setSelectedLot(row);

        if (row.reel_length) {
            setSelectedParentRollLot([row]);
            setNoLength(false);
        }
        else {
            setSelectedParentRollLot([]);
            setNoLength(true);
        }



        // Collect the values of the controls 
        setWinderMONumber(mono);
        setWinderMANumber(mano);

        setAvailableSetLength(row.reel_length);
        setSetLength(row.reel_length);
        setActualSetLength(row.reel_length);
        setGSM(row.gsm);
        setSelectedCore(row.core_id);
        setAchievedDeckleValue(row.achieved_deckle);
        setJumboValue(row.jumbo_width);
        getParticularCombinationDetails(mono, mano, row.reel_length);


        if (row.reel_length === 0) {
            setCombinationStatus(false);
        }

        let itsvalid = true;
        let errmsg = "";

        setOpen(false);
        setSetChildRollsDetails(null);
        setSetNumberList(null);
        SetSelectedSetNumberStatus(null);
        setRefreshSetWeight((prev) => !prev);

        if (winderShiftID === 0) {
            itsvalid = false;
            errmsg = "Please Select Shift Code";
        }

        if (winderShiftID === undefined) {
            itsvalid = false;
            errmsg = "Please Select Shift Code";
        }

        if (itsvalid) {

            // create child roll number
            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_pr_number: selectedParentRollNumber.pr_number,
                p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
                p_shift_id: winderShiftID,
                p_user_name: selectedOperatorName,
                p_release_no: mono,
                p_lot_no: mano,
            };

            setSetwiseChildrollDetail([]);
            get_SelectedLotNumber_status([]);

            // create child rolls
            await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_NEW, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data?.length > 0) {

                        setSetwiseChildrollDetail(data);
                        get_SelectedLotNumber_status(data);
                        setviewWinderParentRollPlanningDetail(true);
                        setviewWinderParentRollSummaryDetail(false);// load already update child reel details

                        const orderDataFilter = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_pr_number: selectedParentRollNumber.pr_number,
                            p_release_no: mono,
                            p_lot_no: mano,

                        };

                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVEMENTS, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                            .then(reelAchievements => {
                                if (reelAchievements?.length > 0) {

                                    setgetChildReelAchievement(reelAchievements);
                                    setviewWinderParentRollSummaryDetail(true);

                                    // get Approved Child Roll List      
                                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                                        .then(resultAchievedRolls => {
                                            setApprovedChildRollNumber((resultAchievedRolls?.length ?? 0) > 0 ? resultAchievedRolls : []);
                                        })
                                        .catch(error => {
                                            alert(error.message);
                                        });
                                }
                                else {
                                    setgetChildReelAchievement([]);
                                }
                            })
                            .catch(error => {
                                alert(error.message);
                            });
                    }
                })
                .catch(error => {
                    setseverityvalue('error');
                    setmessageValue('No data Found. Please check Submit value!');
                    setAlertTitleValue('Error');
                    setOpen(true);
                });
        }

        else {
            setseverityvalue('error');
            setmessageValue(errmsg);
            setAlertTitleValue('Error');
            setOpen(true);
        }
    }



    const [selectedRowIndex, setSelectedRowIndex] = useState(null); // Track selected row
    const [backgroundColor, setBackgroundColor] = useState(colors.primary[500]); // Default background color

    const handleEditClick = (rowIndex) => {
        setSelectedRowIndex(rowIndex); // Set selected row index
        //setBackgroundColor(backgroundColor === colors.primary[500] ? colors.greenAccent[400]: colors.primary[500]); // Toggle background color
    };


    const [parentRollList, setParentRollList] = useState([]);

    useEffect(() => {
        if (selectedParentRollLot?.length > 0) {
            let actualParentRoll = [...selectedParentRollLot];

            if (diffLotsDetail?.length > 0) {
                actualParentRoll = actualParentRoll.concat(diffLotsDetail);
            }

            setParentRollList(actualParentRoll);
        }
    }, [selectedParentRollLot, diffLotsDetail]);

    const [sheetCounts, setSheetCounts] = useState([]);
    const [actualNoOfSheetsProduced, setActualNoOfSheetsProduced] = useState(0);

    const handleInputChange = async (pr_number, value, reel_length, gsm, jumbo) => {

        const numericValue = parseInt(value, 10) || 0;

        setSheetCounts((prev) => {

            // If `sheetCounts` is empty, add the new value directly
            if (prev.length === 0) {

                const setweightVal = (numericValue * gsm * achievedDeckleValue) / 100000000;
                let reelWeightcalculation = (numericValue * gsm * jumboValue) / 100000000;

                setActualNoOfSheetsProduced(numericValue);
                handleAdjustReelLength(numericValue);
                setSetLength(numericValue);

                return [{ pr_number, reelLength: numericValue, setWeight: (setweightVal).toFixed(3), setweight_with_trim: reelWeightcalculation, available_length: reel_length, gsm: gsm, jumbo_width: jumbo }];
            }

            // Calculate the total from the existing values
            const totalSheets = prev.reduce((total, item) => total + (parseInt(item.reelLength, 10) || 0), 0);

            let setweightVal = (numericValue * gsm * achievedDeckleValue) / 100000000;
            let reelWeightcalculation = (numericValue * gsm * jumboValue) / 100000000;

            // Update or add the new entry
            const updatedCounts = prev.filter((item) => item.pr_number !== pr_number);
            updatedCounts.push({ pr_number, reelLength: numericValue, setWeight: (setweightVal).toFixed(3), setweight_with_trim: reelWeightcalculation, available_length: reel_length, gsm: gsm, jumbo_width: jumbo });

            // Update the total with the new value
            const newTotal = totalSheets + numericValue - (prev.find((item) => item.pr_number === pr_number)?.reelLength || 0);

            setActualNoOfSheetsProduced(newTotal);
            setSetLength(newTotal);

            let setweightAll = (newTotal * gsm * achievedDeckleValue) / 100000000;
            setSetWeight(setweightAll.toFixed(3));

            let reelWeightcalculationAll = (newTotal * gsm * jumboValue) / 100000000;
            setSetWeightWithTrim(reelWeightcalculationAll.toFixed(3)); // Round to 3 decimal places for better precision

            if (newTotal > 0) {
                handleAdjustReelLength(newTotal);
            }

            return updatedCounts;
        });
    };

    useEffect(() => {
        if (sheetCounts.length > 0) {

            setTotalJoints(sheetCounts.length - 1);

            if (sheetCounts.length > 1) {

                let sharedReelDetails = sheetCounts.filter((r) => r.pr_number !== selectedParentRollNumber.pr_number);
                let sumOfReelLength = sharedReelDetails.reduce((sum, r) => sum + r.reelLength, 0);

                FormulaReelWeightCalculation(sumOfReelLength, gsm, achievedDeckleValue, sharedQty, setSharedQty);
                SharedSetWeightWithTrimCal(sumOfReelLength, gsm, jumboValue);
                setSharedLength(sumOfReelLength);
            }
            else {
                setSharedLength(0);
                setSharedQty(0);
                setTotalJoints(0);
                setSharedSetWeightWithTrim(0);
            }
        }
        else {
            setActualNoOfSheetsProduced(0);
            setSetLength(0);
            setSetWeight(0);
            setSetDiameter(0);
        }
    }, [sheetCounts, selectedParentRollNumber]);

    useEffect(() => {
        if (parentRollList?.length > 0) {

            if (sheetCounts?.length > 0) {
                // Filter sheetCounts to remove entries where pr_number is not in parentRollList
                const updatedSheetCounts = sheetCounts.filter((sheet) =>
                    parentRollList.some((parent) => parent.pr_number === sheet.pr_number)
                );
                // Update the state with the filtered sheetCounts
                setSheetCounts(updatedSheetCounts);

                // sum of child roll length
                let sumOfReelLength = updatedSheetCounts.reduce((sum, r) => sum + r.reelLength, 0);
                setSetLength(sumOfReelLength);

                // calculate setweight, and setweight with trim value
                setActualNoOfSheetsProduced(sumOfReelLength);
                setSetLength(sumOfReelLength);

                let setweightAll = (sumOfReelLength * gsm * achievedDeckleValue) / 100000000;
                setSetWeight(setweightAll.toFixed(3));

                // calculate diameter
                let reelDiameter = calculateReelDiameter(setweightAll * 1000, gsm, achievedDeckleValue, selectedCore);
                // console.log("Reel Diameter:", reelDiameter, "meters");
                setSetDiameter(reelDiameter);

                let reelWeightcalculationAll = (sumOfReelLength * gsm * jumboValue) / 100000000;
                setSetWeightWithTrim(reelWeightcalculationAll.toFixed(3)); // Round to 3 decimal places for better precision

                // calculate shared reel length and shared weight
                if (updatedSheetCounts.length > 1) {

                    let sharedReelDetails = updatedSheetCounts.filter((r) => r.pr_number !== selectedParentRollNumber.pr_number);
                    let sumOfSharedReelLength = sharedReelDetails.reduce((sum, r) => sum + r.reelLength, 0);

                    FormulaReelWeightCalculation(sumOfSharedReelLength, gsm, achievedDeckleValue, sharedQty, setSharedQty);
                    SharedSetWeightWithTrimCal(sumOfSharedReelLength, gsm, jumboValue);
                    setSharedLength(sumOfSharedReelLength);
                }
                else {
                    setSharedLength(0);
                    setSharedQty(0);
                    setTotalJoints(0);
                    setSharedSetWeightWithTrim(0);
                }


                // calculate actual set length
                let actualReelDetails = updatedSheetCounts.filter((r) => r.pr_number == selectedParentRollNumber.pr_number);
                let sumOfActualReelLength = actualReelDetails.reduce((sum, r) => sum + r.reelLength, 0);
                setActualSetLength(sumOfActualReelLength);

            }
            else {
                setSetLength(0);
                setSetWeight(0);
                setSharedLength(0);
                setSharedQty(0);
                setTotalJoints(0);
                setSetWeightWithTrim(0);
                setSharedSetWeightWithTrim(0);
            }



        }
        else {
            setSheetCounts([]);
            setSetLength(0);
            setSetWeight(0);
            setSharedLength(0);
            setSharedQty(0);
            setTotalJoints(0);
            setSetWeightWithTrim(0);
            setSharedSetWeightWithTrim(0);
        }
    }, [parentRollList, sheetCounts, setSheetCounts]);


    // calculate diameter for reels
    function inchesToMeters(inches) {
        return inches * 0.0254; // Convert inches to meters
    }

    function cmToMeters(cm) {
        return cm * 0.01; // Convert centimeters to meters
    }

    function calculateReelDiameter(setWeight, gsm, achievedDeckleCm, coreDiameterInches) {
        // Convert core diameter from inches to meters
        let coreDiameterMeters = inchesToMeters(coreDiameterInches);

        // Convert achieved deckle from cm to meters
        let achievedDeckleMeters = cmToMeters(achievedDeckleCm);

        // Calculate the reel diameter
        let reelDiameter = Math.sqrt(
            (4 * setWeight) / (Math.PI * gsm * achievedDeckleMeters) + Math.pow(coreDiameterMeters, 2)
        );

        reelDiameter = reelDiameter * 100;
        return reelDiameter.toFixed(1); // Return diameter rounded to 3 decimal places
    }


    // useEffect(() => {

    //     if (callrefreshval) {
    //         let mono = winderMONumber;
    //         let mano = winderMANumber;
    //         setDuplicateSelectedSetID([]);
    //         setSelectedSetID([]);
    //         getParticularCombinationDetails(mono, mano, setLength);
    //         handleRefreshDuplicateSet();
    //         setCallRefreshval(false);
    //     }

    // }, [callrefreshval, setCallRefreshval])

    useEffect(() => {
        const fetchData = async () => {
            if (callrefreshval) {
                try {
                    let mono = winderMONumber;
                    let mano = winderMANumber;

                    setDuplicateSelectedSetID([]);
                    setSelectedSetID([]);

                    await getParticularCombinationDetails(mono, mano, setLength);
                    await handleRefreshDuplicateSet();

                    setCallRefreshval(false);
                } catch (error) {
                    console.error("Error in refresh logic:", error);
                    setCallRefreshval(false); // Ensure flag resets even on error
                }
            }
        };

        fetchData();
    }, [callrefreshval, setCallRefreshval]);




    // execute set wise child roll creation process
    const callSetwiseReelCreationProcess = async () => {

        let setValid = true

        // validation do not allow wrong set value

        if (!isExtraSetModalOpen) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_release_no: winderMONumber,
                p_lot_no: winderMANumber
            }

            await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_COMBINATION_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        if (selectedSetID?.set_id > data[0].sets) {
                            alert("Incorrect set value detected. Please refresh the parent roll data.");
                            setValid = false;
                            return;
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }

        if (setValid) {

            // Validate set ID
            const setId = isExtraSetModalOpen ? duplicateSelectedSetID?.set_id : selectedSetID?.set_id;
            if (!setId || setId === 0) {
                alert("Unable to create child reels for set ID = 0");
                return;
            }

            // Collect the values of the controls
            setWinderMONumber(winderMONumber);
            setWinderMANumber(winderMANumber);
            setOpen(false);
            setSetChildRollsDetails(null);
            setSetNumberList(null);
            SetSelectedSetNumberStatus(null);


            let selectedSetValue = setId;
            let itsvalid = true;
            let errmsg = "";

            // joint status
            let joint_status_value = false;
            let actualSetWeight = 0;    // calculate actual weight  

            if (winderShiftID === 0) {
                itsvalid = false;
                errmsg = "Please Select Shift Code";
            }

            if (winderShiftID === undefined) {
                itsvalid = false;
                errmsg = "Please Select Shift Code";
            }

            if (setLength === '0' || setLength === 0) {
                itsvalid = false;
                errmsg = "Please set Set Length";
            }

            if (!localStorage.getItem('companyid') || localStorage.getItem('companyid').trim() === "") {
                itsvalid = false;
                errmsg = "unable to read company id";
            }

            if (!localStorage.getItem('userID') || localStorage.getItem('userID').trim() === "") {
                itsvalid = false;
                errmsg = "unable to read user detail";
            }

            if (setLength === 0 || setLength === null) {
                itsvalid = false;
                errmsg = "Reel length should not zero";
            }

            const p_parent_roll_date = dayjs(parentRollDate).format("YYYY-MM-DD HH:mm:ss");
            const p_shift_assigned_date = dayjs(shiftDate).format("YYYY-MM-DD HH:mm:ss");

            // Ensure `p_store_receive_date` is not less than `maxFgDate`

            if (p_parent_roll_date && dayjs(p_shift_assigned_date).isBefore(dayjs(p_parent_roll_date))) {
                itsvalid = false;
                errmsg = "Shift date cannot be earlier than the parent roll creation date." + p_parent_roll_date;
            } else if (!p_parent_roll_date) {
                itsvalid = false;
                errmsg = "No valid parent roll creation date found in selected parent roll.";
            }

            // If in duplicate set mode
            if (isExtraSetModalOpen && itsvalid) {

                let isValid = true;
                let validation_msg = '';

                if (duplicateSelectedSetID === '') {
                    validation_msg += 'Please select Set number for duplication process.\n';
                    isValid = false;
                }

                const confirmDelete = window.confirm(`Do you want to create an extra set: ${duplicateNextSet}, as a duplicate of set no. ${duplicateSelectedSetID.set_id}?`);

                if (!confirmDelete) {
                    return;
                }

                if (isValid) {
                    const SaveData = {

                        p_companyid: localStorage.getItem('companyid'),
                        p_plantid: 1,
                        p_user_name: localStorage.getItem('userID'),
                        p_release_no: winderMONumber,
                        p_lot_no: winderMANumber,
                        p_duplicate_set_count: 1,
                        p_selected_set: duplicateSelectedSetID.set_id,
                        p_parent_roll_id: selectedParentRollNumber.id,
                    }

                    await callApi(API_ENDPOINTS.PROD_MANAGEMENT_ADD_EXTRA_SET, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                        .then(data => {
                            if (data && data.length > 0) {

                                if (data[0].result_value == 0) {
                                    // Show a notification when the PDF is downloaded successfully                                
                                    selectedSetValue = duplicateNextSet;
                                }
                                else {
                                    // Show a notification when the PDF is downloaded successfully
                                    toast.success('Unable to Add Extra set value, Kindly check network connection.', { position: toast.POSITION.BOTTOM_CENTER });
                                    return;
                                }
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });
                }
                else {
                    callError('warning', validation_msg, 'Warning');// Update state with error message 
                    return;
                }

            }



            if (totalJoints > 0) {
                joint_status_value = true;
                actualSetWeight = parseFloat((parseFloat(setWeightWithTrim) - parseFloat(sharedSetWeightWithTrim)).toFixed(3));
            }

            if (itsvalid) {

                // create child roll number
                const orderData = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_plantid: 1,
                    p_pr_number: selectedParentRollNumber.pr_number,
                    p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_shift_id: winderShiftID,
                    p_user_name: localStorage.getItem('userID'),
                    p_release_no: winderMONumber,
                    p_lot_no: winderMANumber,
                    p_set_no: selectedSetValue,//selectedSetID.set_id,
                    p_set_length: setLength,
                    p_set_weight: parseFloat(setWeight),
                    p_joint_parent_roll_det: diffLotsDetail,
                    p_joint_status: joint_status_value,
                    p_actual_length: actualSetLength,
                    p_actual_set_weight: actualSetWeight,
                    p_joint_count: totalJoints,
                    p_set_remarks: setRemarks,
                    p_setweight_with_trim: setWeightWithTrim,
                    p_shared_setweignt_with_trim: sharedSetWeightWithTrim,
                    p_involved_reel_details: sheetCounts,
                    p_actual_diameter: setDiameter,
                    p_actual_core_id: selectedCore,
                    p_operator_id: selectedOperatorID,

                };

                let isBasedOnSet = false;
                let linkvalue;

                // Determine the API endpoint
                if (isBasedOnSet) {
                    linkvalue = API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS;
                } else {
                    linkvalue = API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_BASED_ON_REEL_LENGTH;
                }

                // Validate that linkvalue is defined
                if (!linkvalue) {
                    console.error("Error: API endpoint is not defined.");
                    return;
                }

                // Ensure orderData is valid
                if (!orderData || typeof orderData !== 'object') {
                    console.error("Error: Invalid order data.");
                    return;
                }

                // create child rolls
                callApi(linkvalue, 'POST', { 'Content-Type': 'application/json' }, orderData)
                    .then(data => {
                        if (data && data.length > 0) {

                            setSetwiseChildrollDetail(data);
                            get_SelectedLotNumber_status(data);
                            setviewWinderParentRollPlanningDetail(true);

                            // load already update child reel details
                            setviewWinderParentRollSummaryDetail(false);
                            RefreshDataAfterChildRollCreation();
                            setCallRefreshval(true);
                            setSheetCounts([]);
                            setSetLength(0);
                            setActualNoOfSheetsProduced(0);

                            setDuplicateSelectedSetID([]);
                            setSelectedSetID([]);

                            toast.success('New Child Reel Created Successfully', { position: toast.POSITION.BOTTOM_CENTER });

                            const orderDataFilter = {
                                p_companyid: localStorage.getItem('companyid'),
                                p_pr_number: selectedParentRollNumber.pr_number,
                                p_release_no: winderMONumber,
                                p_lot_no: winderMANumber,
                            };

                            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVEMENTS, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                                .then(data => {
                                    if (data && data.length > 0) {
                                        setgetChildReelAchievement(data);
                                        setviewWinderParentRollSummaryDetail(true);

                                        // get Approved Child Roll List      
                                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                                            .then(data => {
                                                if (data && data.length > 0) {

                                                    setApprovedChildRollNumber(data);
                                                    RefreshDataAfterChildRollCreation();

                                                    setCallRefreshval(true);


                                                }
                                                else {
                                                    setApprovedChildRollNumber([]);
                                                }
                                            })
                                            .catch(error => {
                                                alert(error.message);
                                            });
                                    }
                                    else {
                                        setgetChildReelAchievement([]);
                                    }
                                }
                                )
                                .catch(error => {
                                    callError('error', error.message, 'Error');// Update state with error message 
                                });


                        }
                    })
                    .catch(error => {

                        callError('error', 'No data Found. Please check Submit value!' + error.message, 'Error');// Update state with error message 
                    });
            }

            else {

                callError('error', errmsg, 'Error');// Update state with error message 
            }
        }
    }


    const handleReverseSetProcess = () => {

        if (!hasPermission(userPermissions, "Winder Machine Production", "Delete")) {
            alert("Access denied. You don’t have permission to reverse this set.");
            return; // Exit the function if permission is not granted
        }

        if (!selectedSetNumberStatus.setid) {
            toast.error('Please Select Set Number', { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_pr_number: selectedParentRollNumber.pr_number,
            p_user_name: localStorage.getItem('userID'),
            p_release_no: winderMONumber,
            p_lot_no: winderMANumber,
            p_set_no: selectedSetNumberStatus.setid,

        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_REVERSE_SET, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    toast.success(data[0].message_status, { position: toast.POSITION.BOTTOM_CENTER });
                    handleSelectParentRollNumberchange(refreshData);
                }
                else {
                    toast.error(data[0].message_status, { position: toast.POSITION.BOTTOM_CENTER });
                }
            }
            )
            .catch(error => {
                callError('error', error.message, 'Error');// Update state with error message 
            });

    }


    // collect combination details
    const getParticularCombinationDetails = async (mo_number, lot_number, reel_length) => {

        //PARAMETER
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: mo_number,
            p_lot_no: lot_number
        }

        await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_COMBINATION_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setSelectedCombination(data);

                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PROCESSED_SETS, 'POST', { 'Content-Type': 'application/json' }, para)
                        .then(setList => {
                            if (setList && setList.length > 0) {

                                // set total set count
                                let setcount = data[0].sets;
                                let templist = [];

                                // Populate templist with set_id objects
                                for (let i = 1; i <= setcount; i++) {
                                    templist.push({ set_id: i });
                                }

                                // Create a set of set_ids from setList for fast lookup
                                const setListIds = new Set(setList.map(item => item.sets));

                                // Filter out items from templist where set_id exists in setListIds
                                templist = templist.filter(item => !setListIds.has(item.set_id));
                                //console.log(templist); // Check the filtered result


                                if (templist.length > 0) {
                                    //loadMADetails();

                                    if (actualSetLength === 0 || reel_length === 0) {
                                        setCombinationStatus(false);
                                    }
                                    else {
                                        setCombinationStatus(true);
                                    }
                                    setIsExtraSetModalOpen(false);
                                }
                                else {
                                    loadMADetails();
                                    if (reel_length > 0) {
                                        setIsExtraSetModalOpen(true);
                                    } else {
                                        setCombinationStatus(false);
                                    }

                                }
                                setAvailableLot(templist);
                                setSelectedSetID(templist[0]);

                            }
                            else {
                                // set total set count
                                let setcount = data[0].sets;
                                let templist = [];

                                // Populate templist with set_id objects
                                for (let i = 1; i <= setcount; i++) {
                                    templist.push({ set_id: i });
                                }

                                setAvailableLot(templist);

                                setSelectedSetID(templist[0]);
                                setviewWinderParentRollPlanningDetail(false);

                                if (actualSetLength === 0 || reel_length === 0) {
                                    setCombinationStatus(false);
                                }
                                else {
                                    setCombinationStatus(true);
                                }
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });
                }
            })
            .catch(error => {
                alert(error.message);
            });
    };


    // tracking child roll details
    const TrackingCustomerDetail = async () => {

        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_parent_roll_id: selectedParentRollNumber.id
        }

        await callApi(API_ENDPOINTS.PROD_MANAGEMENT_FIND_CHILD_ROLL_WISE_CUSTOMER, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {

                }
            })
            .catch(error => {
                alert(error.message);
            });
    };

    // load reel list
    const loadMADetails = () => {

        let mono = winderMONumber;
        let mano = winderMANumber;

        setviewWinderParentRollPlanningDetail(true);

        // load already update child reel details
        setviewWinderParentRollSummaryDetail(false);

        const orderDataFilter = {
            p_companyid: localStorage.getItem('companyid'),
            p_pr_number: selectedParentRollNumber.pr_number,
            p_release_no: mono,
            p_lot_no: mano,

        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVEMENTS, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
            .then(data => {
                if (data && data.length > 0) {
                    setgetChildReelAchievement(data);
                    setviewWinderParentRollSummaryDetail(true);
                    // get Approved Child Roll List      
                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                        .then(data => {
                            if (data && data.length > 0) {
                                setApprovedChildRollNumber(null);
                                setApprovedChildRollNumber(data);
                            }
                        })
                        .catch(error => {
                            alert(error.message);
                        });
                }
            })
            .catch(error => {
                alert(error.message);
            });

    }




    const handleDelete = (companyId) => { console.log("Delete company with ID:", companyId); }

    useEffect(() => {
        if (callRefresh) {
            RefreshChildRollList();
        }
    }, [callRefresh]);


    // refresh data 

    const RefreshChildRollList = async () => {

        let lot_data;
        let mono = selectedLot.release_no;
        let mano = selectedLot.lot_no;
        // Collect the values of the controls

        setWinderMONumber(mono);
        setWinderMANumber(mano);

        let itsvalid = true;
        let errmsg = "";
        setOpen(false);
        setSetChildRollsDetails(null);
        setSetNumberList(null);
        SetSelectedSetNumberStatus(null);

        if (winderShiftID === 0) {
            itsvalid = false;
            errmsg = "Please Select Shift Code";
        }

        if (winderShiftID === undefined) {
            itsvalid = false;
            errmsg = "Please Select Shift Code";
        }

        if (itsvalid) {
            // create child roll number
            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_pr_number: selectedParentRollNumber.pr_number,
                p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
                p_shift_id: winderShiftID,
                p_user_name: selectedOperatorName,
                p_release_no: mono,
                p_lot_no: mano,
            };

            // create child rolls
            await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setSetwiseChildrollDetail(data);
                        get_SelectedLotNumber_status(data);
                        setviewWinderParentRollPlanningDetail(true);
                        lot_data = data;

                        // load already update child reel details
                        setviewWinderParentRollSummaryDetail(false);
                        const orderDataFilter = {
                            p_companyid: localStorage.getItem('companyid'),
                            p_pr_number: selectedParentRollNumber.pr_number,
                            p_release_no: mono,
                            p_lot_no: mano,

                        };

                        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVEMENTS, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                            .then(data => {
                                if (data && data.length > 0) {
                                    setgetChildReelAchievement(data);
                                    setviewWinderParentRollSummaryDetail(true);

                                    // get Approved Child Roll List      
                                    callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CREATE_CHILD_ROLLS_ACHIVED_ROLL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderDataFilter)
                                        .then(data => {
                                            if (data && data.length > 0) {
                                                setApprovedChildRollNumber(null);
                                                setApprovedChildRollNumber(data);
                                            }
                                        })
                                        .catch(error => {
                                            alert(error.message);
                                        });
                                }
                            })
                            .catch(error => {
                                alert(error.message);
                            });
                    }
                })
                .catch(error => {
                    setseverityvalue('error');
                    setmessageValue('No data Found. Please check Submit value!');
                    setAlertTitleValue('Error');
                    setOpen(true);
                });

        }

        else {
            setseverityvalue('error');
            setmessageValue(errmsg);
            setAlertTitleValue('Error');
            setOpen(true);
        }

        // another funcions 
        SetSelectedSetNumberStatus(selectedDuplicateSetNumberStatus);

        if (lot_data && lot_data.length > 0) {

            const filteredChildRollsDetails = lot_data
                .filter(detail => detail.setid === selectedDuplicateSetNumberStatus.setid)
                .sort((a, b) => a.id - b.id);

            // Check if all rows have the status "approved"
            const allApproved = filteredChildRollsDetails.every(detail => detail.status === 'approved');

            // Set enableReverse based on whether all statuses are approved
            if (allApproved) { setEnableReverse(false); } else { setEnableReverse(true); }

            const booked = filteredChildRollsDetails.find(detail => detail.status === 'Booked' || detail.status === 'booked');

            // Update the state with the filtered chi   ld rolls details
            setSetChildRollsDetails(filteredChildRollsDetails);

            if (booked) {
                setCreateChildBtnDisapled(false);
            }
            else {
                setCreateChildBtnDisapled(true);
            }
            setViewQRCodeDetails(false);
            setSelectedApprovedChildRollNumber(null);
            setCallRefresh(false);
        }
        else {
            setSetChildRollsDetails([]);
        }

    };


    const ChildRollProductDetail = (ChildRollNumber) => {
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_child_reel_number: ChildRollNumber,
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data?.length > 0) {
                    setSelectedProductDetails({
                        ...data[0],
                        achieved_qty: Math.ceil(data[0].achieved_qty * 1000),
                    });

                    const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` +
                        `Quality: ${data[0].item_code || 'XXXXQuality'}, ` +
                        `Size: ${data[0].width || '0'} X ${data[0].length}, ` +
                        `GSM: ${data[0].gsm}, BF: ${data[0].bf || 0}, ` +
                        `ID/OD: ${data[0].core_id || 0} / ${data[0].reel_od || 0}, ` +
                        `Roll.wt: ${data[0].achieved_qty || 0}(Mt), ` +
                        `Reel Length: ${data[0].reel_length || 0} meters, ` +
                        `Customer Number: ${data[0].customer_code || 'XXXXXXX'}`;

                    setQRCodeValue(qrValue);
                }
                else {
                    setSelectedProductDetails([]);
                    setQRCodeValue('');
                }

            })
            .catch(error => { });
    };



    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };



    useEffect(() => {

        // Prepare request data
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "";
        const p_mono = 0;

        const orderData = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };

        // API call
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then((data) => {
                if (data && data.length > 0) {
                    setparentRollNumbers(data);
                } else {
                    setparentRollNumbers([]);
                    console.warn('No parent roll data available for the given range.');
                }
            })
            .catch((error) => {
                console.error('Error fetching parent roll list:', error.message);
            });

    }, [FromDate, ToDate, setFromDate, setToDate, setparentRollNumbers]);


    const handleMOChange = (event, value) => {
        if (value.length > 0) {
            setSelectedMOs(value);
            LoadOrderLineItemDetails(value[0].mono);
        }
        else {
            setSelectedMOs([]);
            setparentRollNumbers([]);
        }

    };


    const LoadOrderLineItemDetails = (MO_number) => {

        setSelectedMO(MO_number);

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: MO_number,
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_LIST_BASED_ON_MO_NUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setparentRollNumbers(data);
                    setviewParentRollList(false);
                } else {
                    // No data found
                    setparentRollNumbers([]);
                    setviewParentRollList(true);
                    callError('info', 'No MO are released this date range, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
            });
    };

    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setseverityvalue(serverityval);
        setmessageValue(msg);
        setAlertTitleValue(title);
        setOpen(true);
    };

    //Setweight with trim
    const SetWeightWithTrimCal = async (reel_length, gsm, jumbowidth) => {
        let reelWeightcalculation = (reel_length * gsm * jumbowidth) / 100000000;
        setSetWeightWithTrim(reelWeightcalculation.toFixed(3)); // Round to 3 decimal places for better precision
    }

    const SharedSetWeightWithTrimCal = async (reel_length, gsm, jumbowidth) => {
        let reelWeightcalculation = (reel_length * gsm * jumbowidth) / 100000000;
        setSharedSetWeightWithTrim(reelWeightcalculation.toFixed(3)); // Round to 3 decimal places for better precision
    }

    const [restrictBookingLength, setRestrictBookingLength] = useState(false);

    // adjust set-length value process
    const handleAdjustReelLength = (value) => {

        const numericValue = Number(value); // Ensure the value is a number
        setOpen(false);

        if (!isNaN(numericValue)) { // Validate it's a number

            if (numericValue > availableSetLength) {

                if (restrictBookingLength) {
                    //setSetLength(availableSetLength);
                    //FormulaReelWeightCalculation(availableSetLength, gsm, achievedDeckleValue, setWeight, setSetWeight);
                    SetWeightWithTrimCal(availableSetLength, gsm, jumboValue);

                    //let sharedLength = diffSetLength;
                    //FormulaReelWeightCalculation(sharedLength, gsm, achievedDeckleValue, sharedQty, setSharedQty);
                    //SharedSetWeightWithTrimCal(sharedLength, gsm, jumboValue);
                    //setSharedLength(sharedLength);
                    //CalculateTotalJoints(availableSetLength);

                    callError('info', 'Set length value cannot be increased beyond the available length.', 'info');
                }
                else {

                }


            } else {
                //setSetLength(numericValue);

                //FormulaReelWeightCalculation(numericValue, gsm, achievedDeckleValue, setWeight, setSetWeight);
                //SetWeightWithTrimCal(numericValue, gsm, jumboValue);

                //let sharedLength = 0;
                // CalculateTotalJoints(numericValue);

                if (numericValue > actualSetLength) {
                    // sharedLength = numericValue - actualSetLength;
                    // FormulaReelWeightCalculation(sharedLength, gsm, achievedDeckleValue, sharedQty, setSharedQty);
                    // SharedSetWeightWithTrimCal(sharedLength, gsm, jumboValue);
                    // setSharedLength(sharedLength);
                }
                else {
                    setSharedLength(0);
                    setSharedQty(0);
                    setTotalJoints(0);
                    setSharedSetWeightWithTrim(0);
                }
            }
        }
    };


    // calculate joints in child roll 



    const CalculateTotalJoints = (AssignedLength) => {
        // Initialize variables
        let numberofjoints = 0; // Start with one joint by default
        let RequiredLength = AssignedLength - actualSetLength;

        // Iterate through diffLotsDetail
        if (AssignedLength > actualSetLength) {
            for (const lot of diffLotsDetail) {
                if (lot.reel_length > RequiredLength) {
                    numberofjoints++;
                    break; // Exit the loop
                } else {
                    RequiredLength -= lot.reel_length;
                    numberofjoints++;
                }
            }
        }

        // Update the total joints state after the loop
        setTotalJoints(numberofjoints);
    };


    // joint parent roll 

    const handleUseLoosePallete = (event) => {
        setJointParentRoll(event.target.checked);

        if (event.target.checked === true) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_release_no: winderMONumber,
                p_lot_no: winderMANumber,
                id_parent_roll: selectedParentRollNumber.id

            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_LIST_BASED_ON_MA_NUMBER, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        // Update state with fetched data
                        setDiffParentRollNumbers(data);
                    } else {
                        // No data found
                        setDiffParentRollNumbers([]);
                        toast.success('No parent rolls available for joining.', { position: toast.POSITION.BOTTOM_CENTER });
                        setJointParentRoll(false);
                    }
                })
                .catch(error => {
                    callError('error', error.message, 'Error');// Update state with error message 
                });

        }
        else {
            setDiffParentRollNumbers([]);
            setDiffLotsDetail([]);
            setviewWinderDifferendParentRollDetail(false);
            setSelectedDiffParentRollNumber(null);

            let differend_lot_length = 0;
            differend_lot_length = availableSetLength - diffSetLength;
            setAvailableSetLength(differend_lot_length);
            setSetLength(differend_lot_length);
            setDiffSetLength(0);
        }
    };


    // refresh data after create child roll process
    const RefreshDataAfterChildRollCreation = async () => {
        // refresh selected lot details
        LoadSelectedLotDetails(selectedParentRollNumber.pr_number, 'refresh');
        const selectedMonos = selectedDiffParentRollNumber.map((item) => item.pr_number);
        LoadSelectedLDiffrendParentRollLotDetailsRefresh(selectedMonos);
    };


    const handleShowNewVendor = () => {
        setAddNewJob(true);
    }


    const [inputValues, setInputValues] = useState({});

    // Initialize input values when parentRollList changes
    useEffect(() => {
        const initialValues = parentRollList.reduce((acc, reel) => {
            acc[reel.pr_number] = 0; // Default value for all inputs
            return acc;
        }, {});
        setInputValues(initialValues);
    }, [parentRollList]);

    const handleChange = (pr_number, value) => {
        if (value >= 0 || value === "") {
            setInputValues((prevValues) => ({
                ...prevValues,
                [pr_number]: value,
            }));
            // Call handleInputChange for further processing
            const reel = parentRollList.find((reel) => reel.pr_number === pr_number);
            handleInputChange(pr_number, value, reel.reel_length, reel.gsm, reel.jumbo_width);
        }
    };


    const DetailRow = ({ label, value }) => (
        <Grid container item xs={12}>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="left">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="subtitle2" textAlign="right" fontWeight="bold">
                    {value}
                </Typography>
            </Grid>
        </Grid>
    );

    // view qr code pop-up style
    const handleOpen = () => {
        setViewQRCodeDetails(true);
    };

    const handleClose = () => {
        setViewQRCodeDetails(false);
    };

    const handleTransferReel = async (child_number) => {
        // alert(child_number);
        setIsTransferReelModalOpen(true);

    }



    // Add Aditional set in this parent roll

    // get actual set counts
    const handleActualSetCount = async (row) => {
        const payload = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: row.release_no,
            p_lot_no: row.lot_no,
        }
        await loadActualSetCount(payload);
    }

    const [duplicateSelectedSetID, setDuplicateSelectedSetID] = useState();
    const [duplicateAvailableLot, setDuplicateAvailableLot] = useState([]);

    const handleSelectedSetDuplicateID = (event, value) => {
        if (value !== undefined && value !== null) {
            setDuplicateSelectedSetID(value); // store the full object
        }
    };

    useEffect(() => {
        handleLoadOrginalSetList();
    }, [actualSetCount], [setActualCount])

    const handleLoadOrginalSetList = async () => {
        if (actualSetCount > 0) {
            let templist = [];
            // Populate templist with set_id objects
            for (let i = 1; i <= actualSetCount; i++) {
                templist.push({ set_id: i });
            }
            setDuplicateAvailableLot(templist);
            setDuplicateSelectedSetID(templist[0]);
        }
    };



    const handleRefreshDuplicateSet = async () => {
        await handleLoadOrginalSetList();
        setIsExtraSetModalOpen(false);
        handleCloseExtraSet();
        // 
    };

    // call edit 
    const handleEditClickAll = async (row) => {
        await handleEdit(row);
        await TrackingCustomerDetail();
        setSelectedLot(row);
        await handleActualSetCount(row);
    }



    return (
        <Box>

            {/* header title */}
            {/* <Header title={t('prod_menu.windermachineproduction')} subtitle="" callback={callback} /> */}
            <QualityCheckRejectProcee rejectReelType={`Reject Child Roll Number : ${selectedChildRollDetails.child_reel_number}`} rejectReason={rejectReason} setRejectReason={setRejectReason} selectedReason={selectedReason} setSelectedReason={setSelectedReason} rejectProductType={rejectProductType} setRejectProductType={setRejectProductType} rejectStatus={rejectStatus} setRejectStatus={setRejectStatus} rejectReasonID={rejectReasonID} setRejectReasonID={setRejectReasonID} rejectRemarks={rejectRemarks} setRejectRemarks={setRejectRemarks} enableReject={enableReject} setEnableReject={setEnableReject} open={openPOPUP} onClose={closepopup} buttonname={'Yes'} message={'Do you really want to reject this Child reel?'} callReject={callRejectionProcess} />

            <Dialog
                open={openBreak}
                onClose={closeBreakpopup}
                fullWidth
                maxWidth="xs"

            >
                <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
                    <ProductionBreakProcess rejectReelType={'PARENTROLL'} />
                </DialogContent>
                <DialogActions sx={{ backgroundColor: theme.palette.background.default }}>
                    <Button onClick={closeBreakpopup} variant="contained">
                        Update
                    </Button>
                </DialogActions>
            </Dialog>

            <Divider />

            {/* Message box detail */}
            <CallAlertBar parentRollMsgOpen={open} setParentRollMsgOpen={setOpen} parentRollSeverityvalue={severityvalue}
                setParentRollSeverityvalue={setseverityvalue} parentRollAlertTitleValue={alertTitleValue}
                setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setmessageValue} />

            {viewWinderJobList && (
                <>
                    <Divider />

                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            {/* First Menu */}
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirst}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}

                            >
                                <MenuItem onClick={() => handleMenuItemClickFirst('Winder Machine Production')}>Winder Machine Production</MenuItem>
                                {/* <MenuItem onClick={() => handleMenuItemClickFirst('Inprogress Parent Roll')}>Inprogress Parent Roll</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirst('Cancelled Parent Roll')}>Cancelled Parent Roll</MenuItem> */}
                            </Menu>

                            {/* Adding margin-left: auto to push the button to the right */}

                            <Box sx={{ marginLeft: 'auto' }}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleOpenWipReelDetails}
                                    sx={{ mr: 2 }}
                                >
                                    View WIP Reels
                                </Button>

                                {hasPermission(userPermissions, "Paper Machine Production", "Create") && (
                                    <Button size="small" variant="contained" disabled onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ textTransform: 'none' }}>New</Button>

                                )}
                            </Box>


                            {/* Second Menu */}
                            {/* <IconButton
                                size="small"
                               
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon sx={{ fontSize: "18px" }} />
                            </IconButton> */}
                            {/* <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Vendors" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Vendors" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu> */}

                            {/* <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ mr: 1, ml: 1 }}
                                onClick={handleMenuClickSecond}
                            >
                                <HelpIcon sx={{ fontSize: "18px" }} />
                            </IconButton> */}

                            <div>
                                <IconButton onClick={handleBackWinderMachineEntry} sx={{ marginLeft: 'auto', textTransform: 'none' }} >
                                    <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>




                </>
            )}


            {addNewJob && (
                <Box
                    sx={{
                        padding: "5px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '85vh', // Large devices (desktops)
                            xl: '89vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>

                    <Grid container  >
                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                            {/* date filter */}

                            <Grid container spacing={0}  >
                                {/* left box value */}

                                <Grid item xs={12} sm={12} md={12} lg={6} xl={5}   >

                                    <Grid container padding="5px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" > {t('prod_winder_machine.filter_by')} </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                            <FormControl fullWidth size="small">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        style={{ marginLeft: '10px' }}
                                                        id="FromDate"
                                                        value={dayjs(FromDate)}
                                                        onChange={(date) => handleDateChange2(date)}
                                                        slotProps={{ textField: { size: 'small', } }}
                                                        renderInput={(props) => <TextField {...props} />}
                                                        autoFocus
                                                        format="DD-MMM-YYYY"
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>



                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                            <FormControl fullWidth size="small" >
                                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                    <DatePicker
                                                        id="ToDate"
                                                        value={dayjs(ToDate)}
                                                        format="DD-MMM-YYYY"
                                                        onChange={(date) => handleDateChange1(date)}
                                                        slotProps={{ textField: { size: 'small', } }}
                                                        renderInput={(props) => <TextField {...props} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                    </Grid>

                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                {t('prod_winder_machine.parent_roll_number')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={7.8} xl={6.2}>
                                            <Autocomplete
                                                fullWidth
                                                autoFocus
                                                variant="standard"
                                                // style={{ width: '300px' }}
                                                value={selectedParentRollNumber}
                                                onChange={handleSelectParentRollNumber}
                                                fontSize="10px"
                                                size="small"
                                                disabled={viewParentRollList}
                                                options={parentRollNumbers}
                                                getOptionLabel={(option) => `${option.pr_number}`} // Assuming lot numbers are strings
                                                renderInput={(params) => <TextField {...params} variant="outlined" />}//label="MO - ParentRoll"
                                            />
                                        </Grid>

                                    </Grid>

                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                {t('prod_winder_machine.shift_date_time')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                            <FormControl fullWidth size="small">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack spacing={1}>
                                                        <DatePicker
                                                            value={dayjs(shiftDate)}
                                                            onChange={(date) => setShiftDate(date)}
                                                            slotProps={{ textField: { size: 'small', variant: "outlined" } }}
                                                            fullWidth
                                                            format="DD-MMM-YYYY" // Use the appropriate format string
                                                            renderInput={(props) => (
                                                                <TextField
                                                                    helperText={shiftdate_errorMessage}
                                                                    error={shiftdate_errorMessage && shiftdate_errorMessage.length ? true : false}
                                                                    {...props}
                                                                />
                                                            )}
                                                        />
                                                    </Stack>
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                            <FormControl fullWidth size="small">
                                                <Autocomplete
                                                    fullWidth
                                                    value={winderShiftCode}
                                                    onChange={handleWinderShiftChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={shiftCodes}
                                                    getOptionLabel={(option) => `${option.shiftcode}`}
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            helperText={errorMessage}
                                                            error={errorMessage && errorMessage.length ? true : false}
                                                            {...params} variant="outlined" />}
                                                />
                                            </FormControl>
                                        </Grid>

                                    </Grid>

                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                {t('prod_winder_machine.winder_operator')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={6} xl={5.6}>
                                            <FormControl fullWidth size="small">
                                                <Autocomplete
                                                    fullWidth
                                                    value={selectedOperator}
                                                    onChange={handleOperatorChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={operator}
                                                    getOptionLabel={(option) => `${option.operator_code}`}
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            {...params} variant="outlined" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                            <Tooltip title="Add new operator" arrow>
                                                <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModal} >
                                                    <AddCircleIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>

                                    </Grid>

                                    {selectedcombination.length > 0 && (
                                        <div>

                                            <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                {actualSetLength != 0 && (
                                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
                                                        <FormControlLabel
                                                            control={<Checkbox size="small" color="secondary" checked={jointParentRoll} onChange={handleUseLoosePallete} />}
                                                            label={<Typography variant="h6" fontSize={14}>
                                                                {t('prod_winder_machine.joint')}
                                                            </Typography>
                                                            } >
                                                        </FormControlLabel>
                                                    </Grid>
                                                )}
                                            </Grid>

                                            <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                {jointParentRoll && Array.isArray(diffParentRollNumbers) && (
                                                    <>
                                                        <Grid item xs={12} sm={12} md={1.6} lg={3.6} xl={3.4} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_winder_machine.select_differend_parent_roll')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={8} lg={7.6} xl={6.2}>
                                                            <Autocomplete
                                                                autoFocus
                                                                variant="standard"
                                                                multiple
                                                                value={selectedDiffParentRollNumber || []}
                                                                onChange={handleSelectDifferendParentRollNumber}
                                                                fontSize="8px"
                                                                size="small"
                                                                disabled={viewParentRollList}
                                                                options={diffParentRollNumbers || []}
                                                                getOptionLabel={(option) => `${option?.pr_number || ''}`}
                                                                renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                            />
                                                        </Grid>
                                                    </>)}
                                            </Grid>
                                        </div>
                                    )}

                                </Grid>

                                {/* right box value */}

                                <Grid item xs={12} sm={12} md={6} lg={5.8} xl={4}>
                                    {viewWinderParentRollDetail && (
                                        <>
                                            {selectedcombination?.[0]?.combinations && (
                                                <>
                                                    <Card sx={{ borderRadius: "12px", boxShadow: 3, marginLeft: "auto" }} >
                                                        <CardHeader
                                                            title="Selected Parent Roll MO & MA Details"
                                                            avatar={<InfoIcon color="secondary" />}
                                                            sx={{ backgroundColor: colors.primary[400], padding: "8px" }}
                                                        />

                                                        <CardContent sx={{ padding: "12px" }}>
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={3}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Selected MO #</Typography>
                                                                </Grid>
                                                                <Grid item xs={9}>
                                                                    <Typography variant="body2">{winderMONumber}</Typography>
                                                                </Grid>

                                                                <Grid item xs={3}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>MA #</Typography>
                                                                </Grid>
                                                                <Grid item xs={9}>
                                                                    <Typography variant="body2">{winderMANumber}</Typography>
                                                                </Grid>

                                                                <Grid item xs={3}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Combination</Typography>
                                                                </Grid>
                                                                <Grid item xs={9}>
                                                                    <Typography variant="body2">{selectedcombination?.[0]?.combinations ?? '—'}</Typography>
                                                                </Grid>

                                                                <Grid item xs={3}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Total Sets</Typography>
                                                                </Grid>
                                                                <Grid item xs={9}>
                                                                    <Typography variant="body2">{selectedcombination?.[0]?.sets ?? 0}</Typography>
                                                                </Grid>

                                                                <Grid item xs={3}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Produced Sets</Typography>
                                                                </Grid>
                                                                <Grid item xs={9}>
                                                                    <Typography variant="body2">{selectedcombination?.[0]?.p_set ?? 0}</Typography>
                                                                </Grid>
                                                            </Grid>

                                                            {actualSetLength !== 0 && setWeight && (
                                                                <>
                                                                    <Divider sx={{ my: 1.5 }} />
                                                                    <Grid container spacing={1}>

                                                                        <Grid item xs={3}>
                                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>Total Set Weight</Typography>
                                                                        </Grid>
                                                                        <Grid item xs={9}>
                                                                            <Typography variant="body2">{setWeight || 0} </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>Core ID / Diameter</Typography>
                                                                        </Grid>
                                                                        <Grid item xs={9}>
                                                                            <Typography variant="body2">{`${selectedCore || 0}/${setDiameter || 0}`} </Typography>
                                                                        </Grid>
                                                                        {sharedLength > 0 && (
                                                                            <>
                                                                                <DetailRow label="Joined Length" value={sharedLength || 0} />
                                                                                <DetailRow label="Joined Length Weight" value={sharedQty || 0} />
                                                                                <DetailRow label="Total Joints in Child Reel" value={totalJoints || 0} />
                                                                            </>
                                                                        )}
                                                                    </Grid>
                                                                </>
                                                            ) || (null)}

                                                            {noLength && (
                                                                <Alert severity="warning" sx={{ mt: 1.5 }}>
                                                                    No balance length is available for this MA number.
                                                                </Alert>
                                                            )}
                                                        </CardContent>

                                                    </Card>
                                                </>
                                            ) || null}
                                        </>
                                    ) || null}
                                </Grid>

                                {/* </Grid> */}


                            </Grid>


                            {/* parent roll numbers */}

                            <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: 'inline-flex', borderBottom: '2px solid', borderColor: colors.primary[400] }} display="flex-start" justifyContent="center">
                                    <Divider />
                                </Grid>
                            </Grid>

                            {viewWinderParentRollDetail && (

                                <Grid container padding="5px 1px 1px 1px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                    <Grid item xs={12} sm={10} md={10} lg={12} xl={12} display="flex-start" justifyContent="center">

                                        <CustomTableContainer colors={colors}>
                                            {lotsDetail.length > 0 && (
                                                <TableContainer>
                                                    <Table size="small" >
                                                        <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                                            <TableRow>

                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>
                                                                </TableCell>

                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>S.NO</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>PARENT ROLL #</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>MO NUMBER</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>MA NUMBER</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>TOTAL SETS</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>PLANNED QUANTITY</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>BALANCE QUANTITY</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>PLANNED LENGTH</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>BALANCE LENGTH</TableCell>
                                                                <TableCell style={{ padding: '4px', textAlign: 'center' }}>REMARKS</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {lotsDetail.map((row, index) => (
                                                                <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }} >

                                                                    <TableCell>
                                                                        <EditIcon
                                                                            sx={{ fontSize: 20, color: "#009688", cursor: "pointer", mr: 1.25 }}
                                                                            onClick={() => {
                                                                                handleEditClickAll(row);
                                                                            }}
                                                                        />
                                                                    </TableCell>

                                                                    {/* handleEditClick(index); */}
                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>

                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'center',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="text"
                                                                            value={`${row.id}`}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'center',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="text"
                                                                            value={row.pr_number}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'center',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="text"
                                                                            value={row.release_no}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'right',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="number"
                                                                            value={row.lot_no}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'right',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="number"
                                                                            value={row.set_no}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'right',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="number"
                                                                            value={row.planned_qty}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'right',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="number"
                                                                            value={row.ma_qty}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'right',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="number"
                                                                            value={row.planned_length}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'right',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="number"
                                                                            value={row.reel_length}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            disabled
                                                                            size="small"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'left',
                                                                                },
                                                                            }}
                                                                            variant="outlined"
                                                                            type="text"
                                                                            value={row.remarks}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </CustomTableContainer>
                                    </Grid>
                                </Grid>

                            )}


                            {/* view combination details */}

                            {selectedcombination.length > 0 && selectedParentRollLot?.length > 0 && (
                                <div>

                                    <Grid item xs={12} sm={12} md={5} lg={11.8} xl={11} display="flex-start" >
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={5} lg={6} xl={5} display="flex-start" padding="20px 0px 10px 0px" sx={{ display: "flex", flexDirection: "column", gap: 1, }} >
                                                <Typography
                                                    variant="h5"
                                                    gutterBottom
                                                    sx={{
                                                        borderBottom: "1px solid #ec407a",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Parent Roll Wise Allocated Reel Length
                                                </Typography>




                                                <CustomTableContainer colors={colors}>

                                                    <TableContainer

                                                    >
                                                        <Table sx={{ borderCollapse: "collapse" }}>
                                                            {/* Table Header */}
                                                            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                                                <TableRow>
                                                                    <TableCell
                                                                        sx={{
                                                                            border: "1px solid #ccc",
                                                                            padding: "4px",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        PARENT ROLL #
                                                                    </TableCell>
                                                                    <TableCell
                                                                        sx={{
                                                                            border: "1px solid #ccc",
                                                                            padding: "4px",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        AVAILABLE LENGTH
                                                                    </TableCell>
                                                                    <TableCell
                                                                        sx={{
                                                                            border: "1px solid #ccc",
                                                                            padding: "4px",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        ENTER ACTUAL LENGTH
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>

                                                            {/* Table Body */}
                                                            <TableBody>
                                                                {parentRollList.map(
                                                                    (reel) =>
                                                                        reel.reel_length > 0 && (
                                                                            <TableRow key={reel.id}>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        border: "1px solid #ccc",
                                                                                        padding: "4px",
                                                                                        textAlign: "center"
                                                                                    }}
                                                                                >
                                                                                    {reel.pr_number}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        border: "1px solid #ccc",
                                                                                        padding: "4px",
                                                                                        textAlign: "right"
                                                                                    }}
                                                                                >
                                                                                    {reel.reel_length}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        border: "1px solid #ccc",
                                                                                        fontWeight: "bold",
                                                                                        padding: "4px",
                                                                                    }}
                                                                                >
                                                                                    <TextField
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                        fullWidth
                                                                                        sx={{
                                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                                border: 'none',
                                                                                            },
                                                                                            '& .MuiInputBase-input': {
                                                                                                padding: '2px',
                                                                                                textAlign: 'RIGHT',
                                                                                            },
                                                                                        }}
                                                                                        type="number"
                                                                                        value={inputValues[reel.pr_number] || 0}
                                                                                        onChange={(e) =>
                                                                                            handleChange(reel.pr_number, e.target.value)
                                                                                        }
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === "-" || e.key === "e") e.preventDefault();
                                                                                        }}
                                                                                        onWheel={(e) => e.preventDefault()}
                                                                                    />
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )
                                                                )}

                                                                {/* Summary Row */}
                                                                <TableRow>
                                                                    <TableCell
                                                                        colSpan={2}
                                                                        align="right"
                                                                        sx={{
                                                                            border: "1px solid #ccc",
                                                                            padding: "4px",
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="h6"
                                                                            sx={{
                                                                                textAlign: "right",
                                                                                margin: 0,
                                                                                // fontWeight: "bold",
                                                                            }}
                                                                        >
                                                                            Total Set Length
                                                                        </Typography>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        sx={{
                                                                            border: "1px solid #ccc",
                                                                            padding: "4px",
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="h6"
                                                                            sx={{
                                                                                textAlign: "RIGHT",
                                                                                fontWeight: "bold",
                                                                                color: "#4caf50",
                                                                                marginRight: "15px"
                                                                            }}
                                                                        >
                                                                            {actualNoOfSheetsProduced}
                                                                        </Typography>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CustomTableContainer>

                                                {/* table view end       */}
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={5} lg={6} xl={7} display="flex-start" padding="40px 0px 10px 20px" sx={{ display: "flex", flexDirection: "column", gap: 1, }} >
                                                <Grid container>
                                                    {
                                                        isExtraSetModalOpen && (<>
                                                            {!noLength && (<>
                                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                                    <Grid item xs={12} sm={12} md={1.6} lg={2.3} xl={1.5} display="flex-start" justifyContent="center">
                                                                        <Typography variant="h6" >  Duplicate set </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={2} lg={2} xl={1} display="flex-start" justifyContent="center">

                                                                        <Autocomplete
                                                                            value={duplicateSelectedSetID}
                                                                            onChange={handleSelectedSetDuplicateID}
                                                                            size="small"
                                                                            options={duplicateAvailableLot}
                                                                            fullWidth
                                                                            getOptionLabel={(option) => `${option.set_id}`} // Assuming lot numbers are strings
                                                                            renderInput={(params) => (
                                                                                <TextField sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '2px',
                                                                                        textAlign: 'left',
                                                                                    },
                                                                                }} {...params} variant="outlined" />
                                                                            )}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={1.6} lg={2.3} xl={1.5} display="flex-start" justifyContent="center">
                                                                        <Typography variant="h6" >  Planned Sets </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={4} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                                        <TextField
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'left',
                                                                                },
                                                                            }}
                                                                            type="number" disabled size="small" width="20px" value={duplicateNextSet} inputProps={{ min: 0 }} ></TextField>
                                                                        {/* onChange={(e) => { setSelectedCore(e.target.value) }}  */}
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                                        <Typography variant="h6" >  Core ID </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={4} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                                        <TextField
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'left',
                                                                                },
                                                                            }}
                                                                            type="number" disabled size="small" width="20px" value={selectedCore} onChange={(e) => { setSelectedCore(e.target.value) }} inputProps={{ min: 0 }} ></TextField>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={2.5} display="flex-start" justifyContent="center">
                                                                        <Button variant="contained" size="small" color="secondary" onClick={handleCancelExtraSet}>Cancel </Button>
                                                                    </Grid>


                                                                </Grid>
                                                            </>)}
                                                        </>) || (<>

                                                            {combinationStatus && (<>
                                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                                    <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                                        <Typography variant="h6" >  Next Set </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2} display="flex-start" justifyContent="center">
                                                                        <Autocomplete
                                                                            value={selectedSetID}
                                                                            onChange={handleSelectLotNumberStatusID}
                                                                            size="small"
                                                                            options={availableLot}
                                                                            getOptionLabel={(option) => `${option.set_id}`} // Assuming lot numbers are strings
                                                                            renderInput={(params) => (
                                                                                <TextField sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiInputBase-input': {
                                                                                        padding: '2px',
                                                                                        textAlign: 'left',
                                                                                    },
                                                                                }} {...params} variant="outlined" />
                                                                            )}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={1.6} lg={2.1} xl={1.8} display="flex-start" justifyContent="center">
                                                                        <Typography variant="h6" >  Core ID </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={4} lg={2} xl={2} display="flex-start" justifyContent="center">
                                                                        <TextField
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    border: 'none',
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '2px',
                                                                                    textAlign: 'left',
                                                                                },
                                                                            }}
                                                                            type="number" disabled size="small" width="20px" value={selectedCore} onChange={(e) => { setSelectedCore(e.target.value) }} inputProps={{ min: 0 }} ></TextField>
                                                                    </Grid>
                                                                    {!noLength && (
                                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                                                            <Button variant="contained" size="small" color="secondary" onClick={handleOpenExtraSetModal}>Add Extra Set</Button>
                                                                        </Grid>
                                                                    )}


                                                                </Grid>
                                                            </>)}
                                                        </>)}
                                                    <Grid container padding="10px 0px 10px 20px" marginBottom={5} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        {/* <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                                                    <Typography variant="h6" >  Remarks </Typography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={4} lg={6.2} xl={5.8} display="flex-start" justifyContent="center">
                                                                    <TextField
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                            borderRadius: '10px',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '0px',
                                                                            textAlign: 'left',
                                                                        },
                                                                        backgroundColor: colors.primary[400],
                                                                        fontFamily: 'Times New Roman, serif', // Updated to 'Times New Roman'
                                                                        fontSize: '10px',
                                                                    }}
                                                                     fullWidth size="small"  multiline value={setRemarks} type="text" onChange={(e) => { setSetRemarks(e.target.value) }} />
                                                                </Grid> */}
                                                    </Grid>


                                                </Grid>
                                            </Grid>
                                            {/* </>
                                            )} */}
                                        </Grid>
                                    </Grid>
                                    {(combinationStatus || isExtraSetModalOpen) && (
                                        <>
                                            {!noLength && (<>
                                                <Grid container padding="5px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                                        <Divider />
                                                    </Grid>
                                                </Grid>
                                                <Grid container padding="10px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                            <Button size="small" variant="contained" color="secondary" onClick={() => callSetwiseReelCreationProcess()}>
                                                                Create Child Roll
                                                            </Button>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </>)}
                                        </>
                                    )}
                                </div>
                            )}


                            {viewWinderParentRollPlanningDetail && (
                                <div>
                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={2} xl={2} display="flex-start" >
                                            <Box sx={{ display: 'inline-flex', borderBottom: '1px solid #ec407a' }}>
                                                <Typography variant="h5" marginLeft="0px" padding="3px" marginTop={0} textAlign="left" >
                                                    {t('prod_winder_machine.planning_set_details')}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="10px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" >  Select Set Number </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={1} xl={1} display="flex-start" justifyContent="center">
                                            <Autocomplete
                                                fullWidth
                                                value={selectedSetNumberStatus}
                                                onChange={handleSelectLotNumberStatus}
                                                size="small"
                                                options={setNumberList}
                                                getOptionLabel={(option) => `${option.setid} `} // Assuming lot numbers are strings
                                                renderInput={(params) => <TextField width="300px" {...params} variant="outlined" />}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Button variant="contained" startIcon={<Replay />} color="secondary" onClick={handleReverseSetProcess}>
                                                Reverse Set
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={10} lg={12} xl={12} display="flex-start" justifyContent="center">
                                            {selectedSetNumberStatus !== null && (
                                                <ViewChildReelTable
                                                    rowvalue={setChildRollsDetails}
                                                    onRowsChange={updateLotSizeChanges}
                                                    ParentRollNumber={selectedParentRollNumber.pr_number}
                                                    RefreshData={RefreshChildRollList}
                                                    handleTransferReel={handleTransferReel}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>

                                    {hasPermission(userPermissions, "Winder Machine Production", "Create") && createChildBtnDisapled === false && (
                                        <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.6} lg={4} xl={4} display="flex-start" justifyContent="center">
                                                {selectedSetNumberStatus !== null && (
                                                    <Button startIcon={<AddIcon />} size="small" variant="contained" color="secondary" onClick={() => { updateChildRollDetails(); }} >
                                                        {t('prod_winder_machine.btn_create_child_rolls')}
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    )}

                                </div>
                            )}


                            {viewWinderParentRollSummaryDetail && (
                                <>
                                    {selectedSetNumberStatus !== null && (
                                        <>
                                            <Grid container padding="10px 0px 10px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={1.6} lg={12} xl={12} display="flex-start" justifyContent="center">

                                                </Grid>
                                            </Grid>

                                            <Grid container padding="10px 0px 10px 20px" sx={{ backgroundColor: colors.primary[400] }} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={3} lg={2} xl={1.2} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6" >  Select Child Roll Number </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                    <Autocomplete
                                                        fullWidth
                                                        value={selectedApprovedChildRollNumber}
                                                        onChange={handleChildRollNumebrChange}
                                                        size="small"
                                                        style={{ width: 200 }}
                                                        options={approvedChildRollNumber}
                                                        getOptionLabel={(option) => `${option.child_reel_number}`} // Assuming lot numbers are strings
                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={1.6} lg={8} xl={6} display="flex-start" justifyContent="center">
                                                    {viewWinderParentRollSummaryDetail && (

                                                        <Stack direction="row" spacing={0} justifyContent="start" alignItems="center">

                                                            {hasPermission(userPermissions, "Winder Machine Production", "Print") && (
                                                                <Grid item md={0} ml="100px" mr="10px">
                                                                    <Tooltip title="Print indivitual Reel code [Alt + P]">
                                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                            <IconButton onClick={() => handleButtonClick('PrintQR')}  >
                                                                                <QrCodeRoundedIcon style={{ color: selectedButton === 'PrintQR' ? "yellow" : "#009688", fontSize: "20px" }} />
                                                                            </IconButton>
                                                                            <span style={{ fontSize: 12 }} onClick={() => handleButtonClick('PrintQR')}>{t('prod_winder_machine.btn_print_qr')}</span>
                                                                        </div>
                                                                    </Tooltip>
                                                                </Grid>
                                                            )}

                                                            {hasPermission(userPermissions, "Winder Machine Production", "Print") && (
                                                                <Grid item md={0} ml="10px" mr="10px">
                                                                    <Tooltip title="Print all reel code [Alt + P]">
                                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                            <IconButton onClick={() => handleButtonClick('PrintQRAll')}  >
                                                                                <QrCode2RoundedIcon style={{ color: selectedButton === 'PrintQRAll' ? "yellow" : "#009688", fontSize: "20px" }} />
                                                                            </IconButton>
                                                                            <span style={{ fontSize: 12 }} onClick={() => handleButtonClick('PrintQRAll')}>{t('prod_winder_machine.btn_print_all_qr')}</span>
                                                                        </div>
                                                                    </Tooltip>
                                                                </Grid>
                                                            )}


                                                            <Grid item md={0} ml="10px" mr="10px">
                                                                <Tooltip title="Reject Reel [Alt + R]">
                                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                        <IconButton onClick={() => openpopup('RejectChild')}  >
                                                                            <ThumbDownAltOutlinedIcon style={{ color: selectedButton === 'RejectChild' ? "yellow" : "#f44336", fontSize: "20px" }} />
                                                                        </IconButton>
                                                                        <span style={{ fontSize: 12 }} onClick={() => openpopup('RejectChild')}>Reject Child Roll</span>
                                                                    </div>
                                                                </Tooltip>
                                                            </Grid>

                                                            <Grid item md={0} ml="10px" mr="10px">
                                                                <Tooltip title="Production Break [Alt + B]">
                                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                        <IconButton onClick={() => openBreakpopup('ProductionBreak')}  >
                                                                            <DangerousOutlinedIcon style={{ color: selectedButton === 'ProductionBreak' ? "yellow" : "#f44336", fontSize: "20px" }} />
                                                                        </IconButton>
                                                                        <span style={{ fontSize: 12 }} onClick={() => openBreakpopup('ProductionBreak')}>Production Break</span>
                                                                    </div>
                                                                </Tooltip>
                                                            </Grid>

                                                            {hasPermission(userPermissions, "Winder Machine Production", "View") && (
                                                                <Grid item md={0} ml="10px" mr="10px">
                                                                    <Tooltip title="View Size wise achievement">
                                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                            <IconButton onClick={() => { setSelectedButton('ViewSummary'); setviewAchievementSummary(true); setViewQRCodeDetails(false); }}  >
                                                                                <SummarizeIcon style={{ color: selectedButton === 'ViewSummary' ? "yellow" : "#7986cb", fontSize: "20px" }} />
                                                                            </IconButton>
                                                                            <span style={{ fontSize: 12 }} onClick={() => { setSelectedButton('ViewSummary'); setviewAchievementSummary(true); setViewQRCodeDetails(false); }}>View Size-wise achievements</span>
                                                                        </div>
                                                                    </Tooltip>
                                                                </Grid>
                                                            )}

                                                        </Stack>
                                                    )}
                                                </Grid>
                                            </Grid>


                                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={7} lg={3.5} xl={3} display="flex-start" justifyContent="center">
                                                    {viewQRCodeDetails && (
                                                        <Card sx={{ backgroundColor: 'transparent', m: 1 }} >
                                                            <Box sx={{ p: 1 }}>
                                                                <LabelChildRollDetails qrCodeValue={''} selectedProductDetails={selectedProductDetails} company_id={localStorage.getItem('companyid')} mode={1} modulename='Winder Machine Production' />
                                                            </Box>
                                                        </Card>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            {viewAchievementSummary && (
                                                <>
                                                    <Grid container padding="5px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={8} lg={7} xl={6} display="flex-start" justifyContent="center">
                                                            <Card sx={{ m: 1 }} >
                                                                <Box sx={{ backgroundColor: colors.blueAccent[600], p: 1 }}>
                                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                                        <Typography marginLeft={1} gutterBottom variant="h5" component="div">
                                                                            {t('prod_winder_machine.size_wise_quanity_achievements')}
                                                                        </Typography>
                                                                    </Stack>
                                                                </Box>
                                                                <Divider />
                                                                <Box >
                                                                    <Stack >
                                                                        <Box>
                                                                            <ViewTableData columns={sizecolumns} rows={getChildReelAchievement} />
                                                                        </Box>
                                                                    </Stack>
                                                                </Box>
                                                            </Card>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            )}

            {/* Modal (Dialog) */}
            <Dialog
                open={viewQRCodeDetails}
                onClose={handleClose}
                fullWidth
                maxWidth="xs" // Adjust size of the modal
            >
                <DialogTitle>Label Child Roll Details</DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ p: 1 }}>
                        <LabelChildRollDetails
                            qrCodeValue={''}
                            selectedProductDetails={selectedProductDetails}
                            company_id={localStorage.getItem('companyid')}
                            mode={1}
                            modulename='Winder Machine Production'
                        />
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Render modal if isModalOpen is true */}
            {
                isModalOpen && <AddOperator onClose={handleCloseModal} open={isModalOpen} />
            }

            {/* {
                isExtraSetModalOpen && <AddExtraSetProduction onClose={handleCloseExtraSet} open={isExtraSetModalOpen} viewWinderParentRollDetail={viewWinderParentRollDetail} winderMONumber={winderMONumber} winderMANumber={winderMANumber} selectedcombination={selectedcombination} actualSetLength={actualSetLength} setWeight={setWeight} selectedCore={selectedCore} setDiameter={setDiameter} sharedLength={sharedLength} sharedQty={sharedQty} totalJoints={totalJoints} noLength={noLength} setNumberList={setNumberList} parentRollId={selectedParentRollNumber.id} />
            } */}

            {isTransferReelModalOpen && <ReelTransferProcess onClose={handleCloseReelTransferModal} open={isTransferReelModalOpen} />}
            <Dialog
                open={openWipReelDetails}
                onClose={handleCloseWipReelDetails}
                fullWidth
                maxWidth="xl"
            >
                <DialogTitle sx={{ m: 0, p: 1.5 }}>
                    <Typography variant="h6">Pending WIP Reel Details</Typography>
                    <IconButton
                        onClick={handleCloseWipReelDetails}
                        sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ p: 0 }}>
                    <ReportWinderProuctionWIPReelsList
                        handleBackWinderMachineEntry={handleCloseWipReelDetails}
                        mode={0}
                    />
                </DialogContent>

                <DialogActions sx={{ p: 1 }}>
                    <Button onClick={handleCloseWipReelDetails} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </Box >
    );
};
export default WinderMachineProduction;